import React, { act, useState } from 'react'
import Toast from '../Toast';

// Firebase

import { getAuth } from 'firebase/auth';
import { db } from '../../firebaseConfig';
import { doc, deleteDoc, setDoc, addDoc } from 'firebase/firestore';

// Functions
import {
    SettingsResponse,
    addCampaign, addLeadSource, addLeadSubSource, addLeadStage, addLeadSubStage,
    addLeadStates, addLeadStatus, addLeadSubStatus, addAdmissionStatus, addLeadSubAdmissionStatus, addWelcomeCallStatus,
    addVisaProcessingStatus, addApplicationStatus, addOfferLetterStatus, addFeePaymentStatus, addFileSubmissionStatus,
    addDepartment, addPrefferedStreams, addProgramTypes, addSuperAgents, addPipeline, addFilterButton, addRegistrationFeeDetails,
    addDocumentCategory,
    updateCampaign, updateLeadSource, updateLeadSubSource, updateLeadStage, updateLeadSubStage,
    updateLeadStates, updateLeadStatus, updateAdmissionStatus, updateLeadSubAdmissionStatus, updateWelcomeCallStatus,
    updateVisaProcessingStatus, updateApplicationStatus, updateOfferLetterStatus, updateFeePaymentStatus, updateFileSubmissionStatus,
    updateDepartment, updatePrefferedStreams, updateProgramTypes, updateSuperAgents, updatePipeline,
    updateLeadSubStatus, updateFilterButton, updateRegistrationFeeDetails, updateDocumentCategory
} from '../../pages/Clients/Admin/Function/SettingsFunctions';
import { useAuth } from '../../AuthContext';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Label } from 'recharts';
import GradientSubmitButton from '../GradientSubmitButton';

interface DocumentWithId {
    id: string;
    data: any;
    sub?: any;
}

interface SettingsModalsProps {
    title: string;
    action: string;
    data?: DocumentWithId[];
    filterSettings?: DocumentWithId[];
    onClose: (message: string | undefined) => void;
}

interface CriteriaOptions {
    checkpointOrder: number;
    criteria: {
        criteriaName: string;
        criteriaValue: {
            id: string;
            name: string;
        }[]
    }[];
}

interface Checkpoint {
    checkpointName: string;
    checkpointDescription: string;
    checkpointOrder: number;
    criteria: {
        criteriaName: string;
        criteriaValue: {
            id: string;
            name: string;
        }[]
    }[];
}


interface LeadAdmissionStatus {
    admissionStatus: string;
    level: number;
}

interface LeadSubAdmissionStatus {
    admissionStatusId: string;
    subAdmissionStatus: string;
}

interface Campaign {
    campaign: string;
}

interface LeadSource {
    source: string;
}

interface LeadSubSource {
    sourceId: string;
    subSource: string;
}

interface LeadStage {
    stage: string;
    priority: number;
    color: string;
}

interface LeadSubStage {
    stageId: string;
    subStage: string;
}

interface LeadSubStatus {
    statusId: string;
    subStatus: string;
}

interface LeadState {
    state: string;
    makeInactive: boolean;
}

interface LeadStatus {
    status: string;
    priority: number;
    color: string;
}

interface LeadWelcomeCallByAdmissionTeamStatus {
    welcomeCallByAdmissionTeamStatus: string;
}

interface LeadVisaFileProcessingStatus {
    visaFileProcessingStatus: string;
}

interface LeadApplicationMovedStatus {
    applicationMovedStatus: string;
}

interface LeadOfferLetterStatus {
    offerLetterStatus: string;
}

interface LeadFeePaymentStatus {
    feePaymentStatus: string;
}

interface LeadFileSubmissionStatus {
    fileSubmissionStatus: string;
}

interface RegistrationFeeDetails {
    registrationFeeDetails: any;
    registrationFeeName: string;
    registrationFeeAmount: string;
}

interface LeadCampaigns {
    campaign: string;
    isActive: boolean;
}

interface PreferredStreams {
    preferredStream: string;
}

interface Users {
    name: string;
}

interface SuperAgent {
    superAgent: string;
}

interface SubAgent {
    name: string;
}

interface DocumentCategory {
    categoryName: string;
    documentValues: string[];
}

interface Destinations {
    name: string;
}

interface Language {
    language: string;
}

const SettingsModal: React.FC<SettingsModalsProps> = ({ title, onClose, action, data, filterSettings }) => {

    console.log('SettingsModal rendered with data:', data);
    console.log('SettingsModal received filterSettings:', filterSettings);


    const auth = getAuth();
    const { userData } = useAuth();

    // State
    const [formData, setFormData] = React.useState({
        campaign: '',
        source: '',
        subSources: [] as { id: string, subSource: string }[],
        stage: '',
        subStages: [] as { id: string, subStage: string }[],
        states: '',
        status: '',
        subStatuses: [] as { id: string, subStatus: string }[],
        priority: '',
        color: '#000000',
        admissionStatus: '',
        subAdmissionStatus: [] as { id: string, subAdmissionStatus: string }[],
        registrationFeeDetails: {
            registrationFeeName: '',
            registrationFeeAmount: ''
        },
        level: '',
        welcomeCallByAdmissionTeamStatus: '',
        visaFileProcessingStatus: '',
        applicationMovedStatus: '',
        offerLetterStatus: '',
        feePaymentStatus: '',
        fileSubmissionStatus: '',
        prefferedStream: '',
        programType: '',
        superAgent: '',
        department: '',
        language: '',
        selectedFilterIds: [] as string[],
        documentCategory: {
            categoryName: '',
            documentValues: [] as string[]
        },
        pipeline: {
            name: '',
            description: '',
            checkpoints: [],
        },
        tabPermissions: [
            {
                name: 'Complete Profile',
                read: false,
                write: false
            },
            {
                name: 'Admission',
                read: false,
                write: false
            },
            {
                name: 'Initiate Services',
                read: false,
                write: false
            },
            {
                name: 'Tasks',
                read: false,
                write: false
            },
            {
                name: 'History',
                read: false,
                write: false
            },
            {
                name: "Documents",
                read: false,
                write: false
            },
            {
                name: "Registration",
                read: false,
                write: false
            },
            {
                name: "University Payout",
                read: false,
                write: false
            },
        ],
        actionPermission: [
            {
                name: 'Add',
                img: `${process.env.PUBLIC_URL}/images/desktop/addCircle.svg`,
                allowed: false
            },
            {
                name: 'Edit',
                img: `${process.env.PUBLIC_URL}/images/desktop/editicon.svg`,
                allowed: false
            },
            {
                name: 'Delete',
                img: `${process.env.PUBLIC_URL}/images/desktop/deleteicon.svg`,
                allowed: false
            },
            {
                name: 'Details',
                img: `${process.env.PUBLIC_URL}/images/desktop/print-preview.svg`,
                allowed: false
            },
            {
                name: 'Transfer',
                img: `${process.env.PUBLIC_URL}/images/desktop/TransferLead.svg`,
                allowed: false
            },
            {
                name: 'Collaborate',
                img: `${process.env.PUBLIC_URL}/images/desktop/collaborate.svg`,
                allowed: false
            },
            {
                name: 'Follow Up',
                img: `${process.env.PUBLIC_URL}/images/desktop/follow-up-leadMngt.svg`,
                allowed: false
            },
            {
                name: 'Cloud Telephony',
                img: `${process.env.PUBLIC_URL}/images/desktop/cloudTelephony.svg`,
                allowed: false
            },
        ],
        bulkActionPermission: [
            {
                id: 1,
                name: "Change Assignee",
                active: true,
                view: false,
            },
            {
                id: 2,
                name: "Change Status",
                active: true,
                view: false,
            },
            {
                id: 3,
                name: "Change Stage",
                active: true,
                view: false,
            },
            {
                id: 4,
                name: "Change State",
                active: true,
                view: false,
            },
            {
                id: 5,
                name: "Add Follow Up",
                active: true,
                view: false,
            },
            {
                id: 6,
                name: "Change ProgramType",
                active: true,
                view: false,
            },
            {
                id: 7,
                name: "Change Intake",
                active: true,
                view: false,
            },
            {
                id: 8,
                name: "Change Stream",
                active: true,
                view: false,
            },
            {
                id: 9,
                name: "Change Country",
                active: true,
                view: false,
            },
            {
                id: 10,
                name: "Mark as closed",
                active: true,
                view: false,
            },
            {
                id: 11,
                name: "Delete Leads",
                active: true,
                view: false
            },
            {
                id: 12,
                name: "Change Affiliate Partner",
                active: true,
                view: false
            },
            {
                id: 13,
                name: "Sent Whatsapp Template",
                active: true,
                view: false
            },
            {
                id: 14,
                name: "Send Email",
                active: true,
                view: false
            },
            {
                id: 15,
                name: "Recycle Leads",
                active: true,
                view: false
            },
            {
                id: 16,
                name: "Change Source",
                active: true,
                view: false
            },
        ],
        sidebarItems: [
            {
                id: 1,
                name: 'Dashboard',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-dashboard.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-dashboard-white.svg`,
                link: [
                    { isAdmin: '/admin/dashboard' },
                    { isManager: '/manager/dashboard' },
                    { isStaff: '/staff/dashboard' }
                ],
                isActive: false,
                isVisible: false,
            },
            {
                id: 2,
                name: 'Follow Ups',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-follow-up.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-follow-up-white.svg`,
                link: '/followups',
                notificationCount: { today: 0, incoming: 0 },
                isActive: false,
                isVisible: false,
            },
            {
                id: 3,
                name: 'Team Management',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-team.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-team-white.svg`,
                link: '/teammanagement',
                isActive: false,
                isVisible: false,
            },
            {
                id: 4,
                name: 'Student Management',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/ActiveLead1.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/Staffmanage1.svg`,
                link: '/leadmanagement',
                isActive: false,
                isVisible: false,
            },
            {
                id: 5,
                name: 'My Collaborations',
                targeted: 'Staff',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-my-collaborations.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-my-collaborations-white.svg`,
                link: '/collaborations',
                isActive: false,
                isVisible: false,
            },
            {
                id: 6,
                name: 'My Tasks',
                targeted: 'Staff',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/hugeicons-task.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/hugeicons-task-white.svg`,
                link: '/staffstask',
                isActive: false,
                isVisible: false,
            },
            {
                id: 7,
                name: 'Billing',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/invoice-outline.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/invoice-outline-white.svg`,
                link: '/invoices',
                isActive: false,
                isVisible: false,
            },
            {
                id: 8,
                name: 'Service',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-service.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/icon-service-white.svg`,
                link: '/service',
                isActive: false,
                isVisible: false,
            },
            {
                id: 9,
                name: 'Settings',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/settings-svgrepo.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/settings-svgrepo-white.svg`,
                link: '/settings',
                isActive: false,
                isVisible: false,
            },
            {
                id: 10,
                name: 'Reports',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/report-svgrepo-com.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/report-svgrepo-com-white.svg`,
                link: '/reports',
                isActive: false,
                isVisible: false,
            },
            {
                id: 11,
                name: 'Migration',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/migration.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/migration-white.svg`,
                link: '/migration',
                isActive: false,
                isVisible: false,
            },
            {
                id: 12,
                name: 'Whatsapp',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/whatsapp.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/whatsapp-white.svg`,
                link: '/whatsapp-business-cloud',
                isActive: false,
                isVisible: false,
            },
            {
                id: 13,
                name: 'Integrations',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/integrations.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/integrations-white.svg`,
                link: '/integrations',
                isActive: false,
                isVisible: false,
            },
            {
                id: 14,
                name: 'Tools',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/tools.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/tools-white.svg`,
                link: '/tools',
                isActive: false,
                isVisible: false,
            },
            {
                id: 15,
                name: 'Audit Logs',
                normalIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/audit-logs.svg`,
                activeIcon: `${process.env.PUBLIC_URL}/images/desktop/sidebaricon/audit-logs-white.svg`,
                link: '/audit-logs',
                isActive: false,
                isVisible: false,
            }
        ],
        filterButton: {
            sourceIds: [] as string[],
            stageIds: [] as string[],
            stateIds: [] as string[],
            statusIds: [] as string[],
            admissionStatusIds: [] as string[],
            welcomeCallStatusIds: [] as string[],
            visaProcessingStatusIds: [] as string[],
            applicationStatusIds: [] as string[],
            conditionalOfferLetterStatusIds: [] as string[],
            unconditionalOfferLetterStatusIds: [] as string[],
            feePaymentStatusIds: [] as string[],
            fileSubmissionStatusIds: [] as string[],
            preferredStreamIds: [] as string[],
            assigneeIds: [] as string[],
            subAgentIds: [] as string[],
            superAgentIds: [] as string[],
            followUpIds: [] as string[],
            campaignIds: [] as string[],
            destinationIds: [] as string[],
            followUpStatus: [] as string[],
        }
    });

    // Options for criteria
    const criteriaOptions = [
        // Application Process
        { label: "Welcome Call Status", value: "leadWelcomeCallByAdmissionTeamStatus", key: "welcomeCallByAdmissionTeamStatus" },
        { label: "Visa Processing Status", value: "leadVisaFileProcessingStatus", key: "visaFileProcessingStatus" },
        { label: "Application Status", value: "leadApplicationMovedStatus", key: "applicationMovedStatus" },
        { label: "Offer Letter Status", value: "leadOfferLetterStatus", key: "offerLetterStatus" },
        // Payments and Documents
        { label: "Fee Payment Status", value: "leadFeePaymentStatus", key: "feePaymentStatus" },
        { label: "File Submission Status", value: "leadFileSubmissionStatus", key: "fileSubmissionStatus" },
        { label: "Registration fees", value: "leadRegistrationFeeDetails", key: "registrationFeeDetails" },
        // Lead Management
        { label: "Lead Source", value: "leadSources", key: "source" },
        { label: "Lead Stage", value: "leadStages", key: "stage" },
        { label: "Lead State", value: "leadStates", key: "state" },
        { label: "Lead Status", value: "leadStatuses", key: "status" },
        { label: "Admission Status", value: "leadAdmissionStatus", key: "admissionStatus" },
        // Admission Process
        { label: "Preferred Streams", value: "preferredStreams", key: "preferredStream" },
        { label: "Program Types", value: "programTypes", key: "programType" },
        // { label: "Super Agent", value: "superAgents", key: "superAgent" },
    ]

    const [optionsData, setOptionsData] = React.useState<{ criteriaId: string, value: string }[]>([]);

    const [pipelineName, setPipelineName] = React.useState('');
    const [pipelineDescription, setPipelineDescription] = React.useState('');
    const [pipelineData, setPipelineData] = React.useState<Checkpoint[]>([
        {
            checkpointName: '',
            checkpointDescription: '',
            checkpointOrder: 1,
            criteria: [
                {
                    criteriaName: '',
                    criteriaValue: []
                }
            ]
        }
    ]);

    const [isUpdating, setIsUpdating] = React.useState(false);

    // Toast
    const [showToast, setShowToast] = React.useState(false);
    const [toastMessage, setToastMessage] = React.useState('');
    const [priorityError, setPriorityError] = React.useState(false);

    // Check if action is edit and call handleActionEdit
    React.useEffect(() => {
        if (action === 'edit' && data) {
            console.log('Action is edit, calling handleActionEdit with data:', data);

            handleActionEdit(data?.[0]);
        }
    }, [action]);

    // Functions
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Clear priority error when user starts typing in priority field
        if (e.target.name === 'priority') {
            setPriorityError(false);
        }

        if (e.target.name === 'level' || e.target.name === 'priority') {
            // only allow numbers
            const re = /^[0-9\b]+$/;
            if (e.target.value === '' || re.test(e.target.value)) {
                setFormData({
                    ...formData,
                    [e.target.name]: e.target.value, // Keep as string for input, convert to number when saving
                });
            }
        }
        else if (e.target.name === 'read' || e.target.name === 'write') {
            const updatedTabPermissions = [...formData.tabPermissions];
            updatedTabPermissions[parseInt(e.target.id)] = {
                ...updatedTabPermissions[parseInt(e.target.id)],
                [e.target.name]: e.target.checked
            };
            setFormData({
                ...formData,
                tabPermissions: updatedTabPermissions
            });
        } else if (e.target.name === 'actionPermission') {
            const updatedActionPermissions = [...formData.actionPermission];
            updatedActionPermissions[parseInt(e.target.id)] = {
                ...updatedActionPermissions[parseInt(e.target.id)],
                allowed: e.target.checked
            };
            setFormData({
                ...formData,
                actionPermission: updatedActionPermissions
            });
        } else if (e.target.name === 'bulkActionPermission') {
            const updatedBulkActions = [...formData.bulkActionPermission];
            updatedBulkActions[parseInt(e.target.id)] = {
                ...updatedBulkActions[parseInt(e.target.id)],
                view: e.target.checked
            };
            setFormData({
                ...formData,
                bulkActionPermission: updatedBulkActions
            });
        } else if (e.target.name === 'sidebarItems') {
            const updatedSidebarItems = [...formData.sidebarItems];
            updatedSidebarItems[parseInt(e.target.id)] = {
                ...updatedSidebarItems[parseInt(e.target.id)],
                isVisible: e.target.checked
            };
            setFormData({
                ...formData,
                sidebarItems: updatedSidebarItems
            });
        } else if (e.target.name === 'registrationFeeName' || e.target.name === 'registrationFeeAmount') {
            setFormData({
                ...formData,
                registrationFeeDetails: {
                    ...formData.registrationFeeDetails,
                    [e.target.name]: e.target.value
                }
            });
        } else if (e.target.name === 'categoryName') {
            setFormData({
                ...formData,
                documentCategory: {
                    ...formData.documentCategory,
                    categoryName: e.target.value
                }
            });
        } else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleSelectAll = (section: string, _attribute: string) => {
        if (section === 'tabPermissions') {
            if (_attribute === 'read') {
                // Filter out Initiate Services, Tasks, Registration and University Payout for Affiliate Departments
                const filteredPermissions = Object.values(formData.tabPermissions).filter((_, index) => {
                    if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                        return false;
                    }
                    return true;
                });
                const value = filteredPermissions.every((item) => item.read);
                setFormData({
                    ...formData,
                    tabPermissions: Object.values(formData.tabPermissions).map((item, index) => {
                        // Skip Initiate Services, Tasks, Registration and University Payout for Affiliate Departments
                        if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                            return item;
                        }
                        return {
                            ...item,
                            read: !value,
                        };
                    }),
                });
            }
            if (_attribute === 'write') {
                // Filter out Initiate Services, Tasks, Registration and University Payout for Affiliate Departments
                const filteredPermissions = Object.values(formData.tabPermissions).filter((_, index) => {
                    if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                        return false;
                    }
                    return true;
                });
                const value = filteredPermissions.every((item) => item.write);
                setFormData({
                    ...formData,
                    tabPermissions: Object.values(formData.tabPermissions).map((item, index) => {
                        // Skip Initiate Services, Tasks, Registration and University Payout for Affiliate Departments
                        if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                            return item;
                        }
                        return {
                            ...item,
                            write: !value,
                        };
                    }),
                });
            }
        } else if (section === 'actionPermission') {
            // Filter out hidden permissions for Affiliate Departments
            const visiblePermissions = Object.values(formData.actionPermission).filter((_, index) => {
                if (title === 'Affiliate Departments' && (index === 4 || index === 5 || index === 6 || index === 7)) {
                    return false;
                }
                return true;
            });

            const value = visiblePermissions.every((item) => item.allowed);
            setFormData({
                ...formData,
                actionPermission: Object.values(formData.actionPermission).map((item, index) => {
                    // Only toggle visible permissions for Affiliate Departments
                    if (title === 'Affiliate Departments' && (index === 4 || index === 5 || index === 6 || index === 7)) {
                        return item; // Keep unchanged
                    }
                    return {
                        ...item,
                        allowed: !value,
                    };
                }),
            });
        } else if (section === 'bulkActionPermission') {
            const value = formData.bulkActionPermission.every((item) => item.view);
            setFormData({
                ...formData,
                bulkActionPermission: Object.values(formData.bulkActionPermission).map((item) => ({
                    ...item,
                    view: !value,
                })),
            });
        } else if (section === 'sidebarItems') {
            const value = formData.sidebarItems.every((item) => item.isVisible);
            setFormData({
                ...formData,
                sidebarItems: Object.values(formData.sidebarItems).map((item) => ({
                    ...item,
                    isVisible: !value,
                })),
            });
        }
    }

    // Fetch criteria options from firestore
    const fetchCriteriaOptions = async (criteriaLabel: string) => {
        try {
            if (userData?.companyId) {
                const criteria = criteriaOptions.find(option => option.label === criteriaLabel);

                const response = await getDocs(collection(db, `companies/${userData.companyId}/${criteria?.value}`));
                // console.log(`Fetched ${criteriaLabel} options:`, response.docs);
                const options = response.docs.map(doc => {
                    const docData = doc.data();
                    console.log('Document data:', docData); // Debug log
                    console.log('Using key:', criteria?.key); // Debug log
                    return {
                        criteriaId: doc.id,
                        value: docData[criteria?.key as string] // Use the key directly as it matches the field name
                    };
                });
                console.log(`Parsed ${criteriaLabel} options:`, options);
                setOptionsData(options);
                return options; // Return the options for use
            }
        } catch (error) {
            console.error(`Error fetching ${criteriaLabel} options:`, error);
            const errorMessage = (error instanceof Error) ? error.message : String(error);
            setToastMessage(`Error fetching ${criteriaLabel} options: ${errorMessage}`);
            setShowToast(true);
            return []; // Return empty array on error
        }
    }

    const handleCheckpointNameChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        console.log(`Updating checkpoint name for index ${index}: ${value}`);

        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];
            if (!updatedPipelineData[index]) {
                updatedPipelineData[index] = {
                    checkpointName: '',
                    checkpointDescription: '',
                    checkpointOrder: index + 1,
                    criteria: []
                };
            }
            updatedPipelineData[index].checkpointName = value; // Update checkpointName
            console.log(`Updated pipelineData at index ${index}:`, updatedPipelineData);
            return updatedPipelineData;
        });
    };

    const handleCheckpointDescriptionChange = (index: number, e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { value } = e.target;
        console.log(`Updating checkpoint description for index ${index}: ${value}`);

        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];
            if (!updatedPipelineData[index]) {
                updatedPipelineData[index] = {
                    checkpointName: '',
                    checkpointDescription: '',
                    checkpointOrder: index + 1,
                    criteria: []
                };
            }
            updatedPipelineData[index].checkpointDescription = value; // Update checkpointDescription
            console.log(`Updated pipelineData at index ${index}:`, updatedPipelineData);
            return updatedPipelineData;
        });
    };


    const handleCriteriaInputChange = (index: number, criteriaIndex: number, e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;

        console.log(`Updating criteria for index ${index}, name: ${name}, value: ${value}`);

        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];
            if (!updatedPipelineData[index]) {
                updatedPipelineData[index] = {
                    checkpointName: '',
                    checkpointDescription: '',
                    checkpointOrder: index + 1,
                    criteria: []
                };
            }

            // Find the criteria that matches the selected value
            const criteriaToUpdate = updatedPipelineData[index].criteria[criteriaIndex];
            if (criteriaToUpdate) {
                criteriaToUpdate.criteriaName = value; // Update criteriaName
            } else {
                // If criteria not found, create a new one
                updatedPipelineData[index].criteria.push({
                    criteriaName: value,
                    criteriaValue: []
                });
            }

            console.log(`Updated pipelineData at index ${index}, criteriaIndex ${criteriaIndex}:`, updatedPipelineData);


            return updatedPipelineData;
        });

    }

    const handleValueChange = (
        index: number,
        criteriaIndex: number,
        e: React.ChangeEvent<HTMLSelectElement> | { target: { value: string | { id: string; name: string }[] } }
    ) => {
        const { value } = e.target;

        // Handle array case (from Select All)
        if (Array.isArray(value)) {
            setPipelineData((prevPipelineData) => {
                const updatedPipelineData = [...prevPipelineData];

                if (!updatedPipelineData[index]) {
                    updatedPipelineData[index] = {
                        checkpointName: '',
                        checkpointDescription: '',
                        checkpointOrder: index + 1,
                        criteria: []
                    };
                }

                if (!updatedPipelineData[index].criteria[criteriaIndex]) {
                    updatedPipelineData[index].criteria[criteriaIndex] = {
                        criteriaName: '',
                        criteriaValue: []
                    };
                }

                // Replace all values with the new array
                updatedPipelineData[index].criteria[criteriaIndex].criteriaValue = value;

                return updatedPipelineData;
            });
            return;
        }

        // Handle single select case (original implementation)
        console.log(`Adding value for index ${index}, criteriaIndex ${criteriaIndex}, value: ${value}`);

        const option = optionsData.find(opt => opt.criteriaId === value);
        if (!option) {
            console.error(`No option found for value: ${value}`);
            return;
        }

        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];

            if (!updatedPipelineData[index]) {
                updatedPipelineData[index] = {
                    checkpointName: '',
                    checkpointDescription: '',
                    checkpointOrder: index + 1,
                    criteria: []
                };
            }

            if (!updatedPipelineData[index].criteria[criteriaIndex]) {
                updatedPipelineData[index].criteria[criteriaIndex] = {
                    criteriaName: '',
                    criteriaValue: []
                };
            }

            const existingItem = updatedPipelineData[index].criteria[criteriaIndex].criteriaValue.find(
                item => item.id === option.criteriaId
            );

            if (!existingItem) {
                updatedPipelineData[index].criteria[criteriaIndex].criteriaValue.push({
                    id: option.criteriaId,
                    name: option.value
                });
                console.log(`Added new value to pipelineData at index ${index}, criteriaIndex ${criteriaIndex}`);
            } else {
                console.log(`Value already exists, skipping duplicate: ${option.value}`);
            }

            return updatedPipelineData;
        });
    };

    const handleAddCheckpoint = (e: any) => {
        e.preventDefault(); // Prevent default form submission behavior

        setPipelineData((prevPipelineData) => [
            ...prevPipelineData,
            {
                checkpointName: '',
                checkpointDescription: '',
                checkpointOrder: prevPipelineData.length + 1,
                criteria: [
                    {
                        criteriaName: '',
                        criteriaValue: []
                    }
                ]
            }
        ]);
    };

    const handleRemoveCheckpoint = (index: number) => {
        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];
            updatedPipelineData.splice(index, 1); // Remove the checkpoint at the specified index
            return updatedPipelineData;
        });
    };

    const handleAddCriteria = (index: number, criteriaIndex: number) => {
        console.log(`Adding criteria for checkpoint at index ${index}, criteriaIndex ${criteriaIndex}`);

        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];

            // Ensure the checkpoint exists
            if (!updatedPipelineData[index]) {
                updatedPipelineData[index] = {
                    checkpointName: '',
                    checkpointDescription: '',
                    checkpointOrder: index + 1,
                    criteria: []
                };
            } else {
                // Create a new checkpoint object to avoid mutation
                updatedPipelineData[index] = {
                    ...updatedPipelineData[index],
                    criteria: [...updatedPipelineData[index].criteria]
                };
            }

            // Ensure the criteria exists at the specified index
            if (!updatedPipelineData[index].criteria[criteriaIndex]) {
                // Fill any gaps in the criteria array
                while (updatedPipelineData[index].criteria.length <= criteriaIndex) {
                    updatedPipelineData[index].criteria.push({
                        criteriaName: '',
                        criteriaValue: []
                    });
                }
            }

            // Add a new criteria to the criteria array (immutably)
            updatedPipelineData[index].criteria = [
                ...updatedPipelineData[index].criteria,
                {
                    criteriaName: '',
                    criteriaValue: []
                }
            ];

            console.log(`Added new criteria to pipelineData at index ${index}, criteriaIndex ${criteriaIndex}`);
            return updatedPipelineData;
        });
    };

    const handleRemoveCriteria = (checkpointIndex: number, criteriaIndex: number) => {
        console.log(`Removing criteria at checkpointIndex ${checkpointIndex}, criteriaIndex ${criteriaIndex}`);

        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];

            // Ensure the checkpoint exists
            if (updatedPipelineData[checkpointIndex]) {
                // Create a new criteria array without the specified criteria
                updatedPipelineData[checkpointIndex].criteria = updatedPipelineData[checkpointIndex].criteria.filter(
                    (_, idx) => idx !== criteriaIndex
                );

                console.log(`Removed criteria at index ${criteriaIndex} from checkpoint ${checkpointIndex}`);
            } else {
                console.warn(`Checkpoint at index ${checkpointIndex} does not exist`);
            }

            return updatedPipelineData;
        });
    };

    // Remove items from values according to idx from value array from the criteria
    const handleRemoveItem = (index: number, criteriaIndex: number, idx: number) => {
        setPipelineData((prevPipelineData) => {
            const updatedPipelineData = [...prevPipelineData];

            if (updatedPipelineData[index] && updatedPipelineData[index].criteria[criteriaIndex]) {
                // Create a new criteria object with updated criteriaValue array
                const updatedCriteria = [...updatedPipelineData[index].criteria];
                updatedCriteria[criteriaIndex] = {
                    ...updatedCriteria[criteriaIndex],
                    criteriaValue: updatedCriteria[criteriaIndex].criteriaValue.filter((_, i) => i !== idx)
                };

                // Create a new pipeline item with updated criteria
                updatedPipelineData[index] = {
                    ...updatedPipelineData[index],
                    criteria: updatedCriteria
                };
            }

            return updatedPipelineData;
        });
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // Reset priority error state
        setPriorityError(false);

        // Priority validation for Lead Stages and Lead Status
        if ((title === 'Lead Stages' || title === 'Lead Status')) {
            // Convert priority to string for validation, handle both string and number types
            const priorityStr = String(formData.priority || '');

            if (!priorityStr.trim()) {
                setToastMessage('Error: Priority field is mandatory and cannot be empty');
                setShowToast(true);
                setPriorityError(true);
                return;
            }

            // Validate priority is a number for Lead Stages and Lead Status
            const priorityNum = parseInt(priorityStr);
            if (isNaN(priorityNum) || priorityNum < 0) {
                setToastMessage('Error: Priority must be a valid positive number');
                setShowToast(true);
                setPriorityError(true);
                return;
            }
        }

        // validation for substages if they exist
        if (formData.subStages && formData.subStages.length > 0) {
            const emptySubStages = formData.subStages.filter(sub => !sub.subStage.trim());
            if (emptySubStages.length > 0) {
                setToastMessage('Error: Sub stage names cannot be empty');
                setShowToast(true);
                return;
            }
        }
        // For subSources
        if (formData.subSources && formData.subSources.length > 0) {
            const emptySubSources = formData.subSources.filter(sub => !sub.subSource.trim());
            if (emptySubSources.length > 0) {
                setToastMessage('Error: Sub source names cannot be empty');
                setShowToast(true);
                return;
            }
        }

        // For subStatuses
        if (formData.subStatuses && formData.subStatuses.length > 0) {
            const emptySubStatuses = formData.subStatuses.filter(sub => !sub.subStatus.trim());
            if (emptySubStatuses.length > 0) {
                setToastMessage('Error: Sub status names cannot be empty');
                setShowToast(true);
                return;
            }
        }

        // for subAdmissionStatus
        if (formData.subAdmissionStatus && formData.subAdmissionStatus.length > 0) {
            const emptySubAdmissionStatus = formData.subAdmissionStatus.filter(sub => !sub.subAdmissionStatus.trim());
            if (emptySubAdmissionStatus.length > 0) {
                setToastMessage('Error: Sub admission status names cannot be empty');
                setShowToast(true);
                return;
            }
        }

        // Validation for Admission Status Level field
        if (title === 'Admission Status') {
            if (!formData.level || formData.level.toString().trim() === '') {
                setToastMessage('Error: Level field is mandatory for Admission Status');
                setShowToast(true);
                return;
            }

            // Validate that level is a positive number
            const levelNum = parseInt(String(formData.level || '0'));
            if (isNaN(levelNum) || levelNum < 0) {
                setToastMessage('Error: Level must be a valid positive number');
                setShowToast(true);
                return;
            }
        }

        setIsUpdating(true);
        let response: SettingsResponse | undefined;

        if (title === 'Campaigns') {
            if (action === 'edit') {
                response = await updateCampaign(
                    db, auth.currentUser, { value: formData?.campaign.toLocaleUpperCase() }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addCampaign(
                    db, auth.currentUser, { value: formData?.campaign.toLocaleUpperCase() }
                );
            }
        } else if (title === 'Lead Sources') {
            if (action === 'edit') {
                response = await updateLeadSource(
                    db, auth.currentUser, { value: formData?.source }, data?.[0]?.id ?? ''
                );

                // Handle deletion of removed subSources
                if (data?.[0]?.sub && Array.isArray(data[0].sub)) {
                    const originalSubSourceIds = data[0].sub.map((sub: any) => sub.id);
                    const currentSubSourceIds = formData?.subSources?.map(sub => sub.id).filter(Boolean) || [];
                    const removedSubSourceIds = originalSubSourceIds.filter((id: string) => !currentSubSourceIds.includes(id));
                    
                    // Delete removed subSources from database
                    for (const removedId of removedSubSourceIds) {
                        if (userData?.companyId) {
                            await deleteDoc(doc(db, `companies/${userData.companyId}/leadSubSources`, removedId));
                        }
                    }
                }

                // Update subSources if they exist
                if (formData?.subSources && formData?.subSources.length > 0) {
                    for (const subSource of formData?.subSources) {
                        if (subSource.id) {
                            await updateLeadSubSource(
                                db, auth.currentUser, { value: subSource.subSource }, subSource.id
                            );
                        } else {
                            // If no ID, add as new subSource
                            await addLeadSubSource(
                                db, auth.currentUser, { value: subSource.subSource, id: response?.data.id ?? '' }
                            );
                        }
                    }
                }

            } else {
                response = await addLeadSource(
                    db, auth.currentUser, { value: formData?.source }
                );

                if (formData?.subSources && formData?.subSources.length > 0) {
                    for (const subSource of formData?.subSources) {
                        await addLeadSubSource(
                            db, auth.currentUser, { value: subSource.subSource, id: response?.data.id ?? '' }
                        );
                    }
                }
            }
        } else if (title === 'Admission Status') {
            if (action === 'edit') {
                response = await updateAdmissionStatus(
                    db, auth.currentUser, { value: formData?.admissionStatus, level: parseInt(String(formData?.level || '0')) }, data?.[0]?.id ?? ''
                );

                // Handle deletion of removed subAdmissionStatuses
                if (data?.[0]?.sub && Array.isArray(data[0].sub)) {
                    const originalSubAdmissionStatusIds = data[0].sub.map((sub: any) => sub.id);
                    const currentSubAdmissionStatusIds = formData?.subAdmissionStatus?.map(sub => sub.id).filter(Boolean) || [];
                    const removedSubAdmissionStatusIds = originalSubAdmissionStatusIds.filter((id: string) => !currentSubAdmissionStatusIds.includes(id));
                    
                    // Delete removed subAdmissionStatuses from database
                    for (const removedId of removedSubAdmissionStatusIds) {
                        if (userData?.companyId) {
                            await deleteDoc(doc(db, `companies/${userData.companyId}/leadAdmissionSubStatus`, removedId));
                        }
                    }
                }

                // Update subAdmissionStatus if they exist
                if (formData?.subAdmissionStatus && formData?.subAdmissionStatus.length > 0) {
                    for (const subStatus of formData?.subAdmissionStatus) {
                        if (subStatus.id) {
                            await updateLeadSubAdmissionStatus(
                                db, auth.currentUser, { value: subStatus.subAdmissionStatus }, subStatus.id
                            );
                        } else {
                            // If no ID, add as new subAdmissionStatus
                            await addLeadSubAdmissionStatus(
                                db, auth.currentUser, { value: subStatus.subAdmissionStatus, id: response?.data.id ?? '' }
                            );
                        }
                    }
                }
            } else {
                response = await addAdmissionStatus(
                    db, auth.currentUser, { value: formData?.admissionStatus, level: parseInt(String(formData?.level || '0')) }
                );

                if (formData?.subAdmissionStatus && formData?.subAdmissionStatus.length > 0) {
                    for (const subStatus of formData?.subAdmissionStatus) {
                        await addLeadSubAdmissionStatus(
                            db, auth.currentUser, { value: subStatus.subAdmissionStatus, id: response?.data.id ?? '' }
                        );
                    }
                }
            }
        } else if (title === 'Welcome Call Status') {
            if (action === 'edit') {
                response = await updateWelcomeCallStatus(
                    db, auth.currentUser, { value: formData?.welcomeCallByAdmissionTeamStatus }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addWelcomeCallStatus(
                    db, auth.currentUser, { value: formData?.welcomeCallByAdmissionTeamStatus }
                );
            }
        } else if (title === 'Visa Processing') {
            if (action === 'edit') {
                response = await updateVisaProcessingStatus(
                    db, auth.currentUser, { value: formData?.visaFileProcessingStatus }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addVisaProcessingStatus(
                    db, auth.currentUser, { value: formData?.visaFileProcessingStatus }
                );
            }
        } else if (title === 'Application Status') {
            if (action === 'edit') {
                response = await updateApplicationStatus(
                    db, auth.currentUser, { value: formData?.applicationMovedStatus }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addApplicationStatus(
                    db, auth.currentUser, { value: formData?.applicationMovedStatus }
                );
            }
        } else if (title === 'Offer Letter Status') {
            if (action === 'edit') {
                response = await updateOfferLetterStatus(
                    db, auth.currentUser, { value: formData?.offerLetterStatus }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addOfferLetterStatus(
                    db, auth.currentUser, { value: formData?.offerLetterStatus }
                );
            }
        } else if (title === 'Fee Payment Status') {
            if (action === 'edit') {
                response = await updateFeePaymentStatus(
                    db, auth.currentUser, { value: formData?.feePaymentStatus }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addFeePaymentStatus(
                    db, auth.currentUser, { value: formData?.feePaymentStatus }
                );
            }
        } else if (title === 'File Submission Status') {
            if (action === 'edit') {
                response = await updateFileSubmissionStatus(
                    db, auth.currentUser, { value: formData?.fileSubmissionStatus }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addFileSubmissionStatus(
                    db, auth.currentUser, { value: formData?.fileSubmissionStatus }
                );
            }
        } else if (title === 'Registration fees') {
            if (action === 'edit') {
                response = await updateRegistrationFeeDetails(
                    db,
                    auth.currentUser,
                    {
                        value: "",
                        registrationFeeDetails: formData?.registrationFeeDetails
                    },
                    data?.[0]?.id ?? ''
                );
            } else {
                response = await addRegistrationFeeDetails(
                    db,
                    auth.currentUser,
                    {
                        value: "",
                        registrationFeeDetails: formData?.registrationFeeDetails
                    }
                );
            }
        } else if (title === 'Document Categories') {
            if (action === 'edit') {
                response = await updateDocumentCategory(
                    db,
                    auth.currentUser,
                    {
                        value: formData?.documentCategory?.categoryName || "",
                        documentCategory: formData?.documentCategory
                    },
                    data?.[0]?.id ?? ''
                );
            } else {
                response = await addDocumentCategory(
                    db,
                    auth.currentUser,
                    {
                        value: formData?.documentCategory?.categoryName || "",
                        documentCategory: formData?.documentCategory
                    }
                );
            }
        } else if (title === 'Lead Stages') {
            if (action === 'edit') {
                response = await updateLeadStage(
                    db, auth.currentUser, {
                    value: formData?.stage,
                    priority: parseInt(String(formData?.priority || '0')), // Convert to number
                    color: formData?.color
                }, data?.[0]?.id ?? ''
                );

                // Handle deletion of removed subStages
                if (data?.[0]?.sub && Array.isArray(data[0].sub)) {
                    const originalSubStageIds = data[0].sub.map((sub: any) => sub.id);
                    const currentSubStageIds = formData?.subStages?.map(sub => sub.id).filter(Boolean) || [];
                    const removedSubStageIds = originalSubStageIds.filter((id: string) => !currentSubStageIds.includes(id));
                    
                    // Delete removed subStages from database
                    for (const removedId of removedSubStageIds) {
                        if (userData?.companyId) {
                            await deleteDoc(doc(db, `companies/${userData.companyId}/leadSubStages`, removedId));
                        }
                    }
                }

                if (formData?.subStages && formData?.subStages.length > 0) {
                    for (const subStage of formData?.subStages) {
                        if (subStage.id) {
                            await updateLeadSubStage(
                                db, auth.currentUser, { value: subStage.subStage }, subStage.id
                            );
                        } else {
                            // If no ID, add as new subStage
                            await addLeadSubStage(
                                db, auth.currentUser, { value: subStage.subStage, id: response?.data.id ?? '' }
                            );
                        }
                    }
                }

            } else {
                response = await addLeadStage(
                    db, auth.currentUser, {
                    value: formData?.stage,
                    priority: parseInt(String(formData?.priority || '0')), // Convert to number
                    color: formData?.color
                }
                );

                if (formData?.subStages && formData?.subStages.length > 0) {

                    for (const subStage of formData?.subStages) {
                        await addLeadSubStage(
                            db, auth.currentUser, { value: subStage.subStage, id: response?.data.id ?? '' }
                        );
                    }
                }
            }
        } else if (title === 'Lead States') {
            if (action === 'edit') {
                response = await updateLeadStates(
                    db, auth.currentUser, { value: formData?.states, color: formData?.color }, data?.[0]?.id ?? ''
                );

            } else {
                response = await addLeadStates(
                    db, auth.currentUser, { value: formData?.states, color: formData?.color }
                );
            }
        } else if (title === 'Lead Status') {
            if (action === 'edit') {
                response = await updateLeadStatus(
                    db, auth.currentUser, {
                    value: formData?.status,
                    priority: parseInt(String(formData?.priority || '0')), // Convert to number
                    color: formData?.color
                }, data?.[0]?.id ?? ''
                );

                // Handle deletion of removed subStatuses
                if (data?.[0]?.sub && Array.isArray(data[0].sub)) {
                    const originalSubStatusIds = data[0].sub.map((sub: any) => sub.id);
                    const currentSubStatusIds = formData?.subStatuses?.map(sub => sub.id).filter(Boolean) || [];
                    const removedSubStatusIds = originalSubStatusIds.filter((id: string) => !currentSubStatusIds.includes(id));
                    
                    // Delete removed subStatuses from database
                    for (const removedId of removedSubStatusIds) {
                        if (userData?.companyId) {
                            await deleteDoc(doc(db, `companies/${userData.companyId}/leadSubStatuses`, removedId));
                        }
                    }
                }

                if (formData?.subStatuses && formData?.subStatuses.length > 0) {
                    for (const subStatus of formData?.subStatuses) {
                        if (subStatus.id) {
                            await updateLeadSubStatus(
                                db, auth.currentUser, { value: subStatus.subStatus }, subStatus.id
                            );
                        } else {
                            // If no ID, add as new subStatus
                            await addLeadSubStatus(
                                db, auth.currentUser, { value: subStatus.subStatus, id: response?.data.id ?? '' }
                            );
                        }
                    }
                }
            } else {
                response = await addLeadStatus(
                    db, auth.currentUser, {
                    value: formData?.status,
                    priority: parseInt(String(formData?.priority || '0')), // Convert to number
                    color: formData?.color
                }
                );

                if (formData?.subStatuses && formData?.subStatuses.length > 0) {
                    for (const subStatus of formData?.subStatuses) {
                        await addLeadSubStatus(
                            db, auth.currentUser, { value: subStatus.subStatus, id: response?.data.id ?? '' }
                        );
                    }
                }
            }
        } else if (title === 'Preffered Stream') {

            if (!formData.prefferedStream) {
                setToastMessage('Error: Preferred Stream is required');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            if (action === 'edit') {
                response = await updatePrefferedStreams(
                    db, auth.currentUser, { value: formData?.prefferedStream }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addPrefferedStreams(
                    db, auth.currentUser, { value: formData?.prefferedStream }
                );
            }
        } else if (title === 'Program Type') {
            if (!formData.programType) {
                setToastMessage('Error: Program Type is required');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            if (action === 'edit') {
                response = await updateProgramTypes(
                    db, auth.currentUser, { value: formData?.programType }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addProgramTypes(
                    db, auth.currentUser, { value: formData?.programType }
                );
            }
        } else if (title === 'Super Agent') {
            console.log(formData?.superAgent);

            if (action === 'edit') {
                response = await updateSuperAgents(
                    db, auth.currentUser, { value: formData?.superAgent }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addSuperAgents(
                    db, auth.currentUser, { value: formData?.superAgent }
                );
            }
        } else if (title === 'Languages') {
            console.log(formData?.language);

            if (action === 'edit') {
                const docRef = doc(db, `companies/${userData?.companyId}/language`, data?.[0]?.id ?? '');
                await setDoc(docRef, {
                    language: formData?.language
                });
                response = { success: true, message: 'Language updated successfully', data: { id: docRef.id } };
            } else {
                const languageCollection = collection(db, `companies/${userData?.companyId}/language`);
                const docRef = await addDoc(languageCollection, {
                    language: formData?.language
                });
                response = { success: true, message: 'Language added successfully', data: { id: docRef.id } };
            }
        } else if (title === 'Departments') {

            if (!formData.department) {
                setToastMessage('Error: Department name is required');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            const hasInvalidPermissions = Object.values(formData.tabPermissions).some(item =>
                item.read === false && item.write === true
            );

            if (hasInvalidPermissions) {
                setToastMessage('Error: Cannot have Write permission without Read permission');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            if (action === 'edit') {
                response = await updateDepartment(
                    db, auth.currentUser, { value: formData?.department, selectedFilterIds: formData.selectedFilterIds, tabPermissions: formData?.tabPermissions, actionPermission: formData.actionPermission, bulkActionPermission: formData.bulkActionPermission, sidebarNavigation: formData.sidebarItems, departmentFor: 'departments' }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addDepartment(
                    db, auth.currentUser, { value: formData?.department, selectedFilterIds: formData.selectedFilterIds, tabPermissions: formData?.tabPermissions, actionPermission: formData.actionPermission, bulkActionPermission: formData.bulkActionPermission, sidebarNavigation: formData.sidebarItems, departmentFor: 'departments' }
                );
            }
        } else if (title === 'Affiliate Departments') {

            if (!formData.department) {
                setToastMessage('Error: Department name is required');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            const hasInvalidPermissions = Object.values(formData.tabPermissions).some(item =>
                item.read === false && item.write === true
            );

            if (hasInvalidPermissions) {
                setToastMessage('Error: Cannot have Write permission without Read permission');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            if (action === 'edit') {
                response = await updateDepartment(
                    db, auth.currentUser, { value: formData?.department, tabPermissions: formData?.tabPermissions, actionPermission: formData.actionPermission, departmentFor: 'subAgentPermissions' }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addDepartment(
                    db, auth.currentUser, { value: formData?.department, tabPermissions: formData?.tabPermissions, actionPermission: formData.actionPermission, departmentFor: 'subAgentPermissions' }
                );
            }
        } else if (title === 'Pipeline') {
            if (!pipelineName) {
                setToastMessage('Error: Pipeline name is required');
                setShowToast(true);
            }
            if (pipelineData.length === 0) {
                setToastMessage('Error: At least one checkpoint is required');
                setShowToast(true);
            }

            if (pipelineData.some(checkpoint => !checkpoint.checkpointName)) {
                setToastMessage('Error: All checkpoints must have a name and description');
                setShowToast(true);
            }

            if (pipelineData.some(checkpoint => checkpoint.criteria.length === 0)) {
                setToastMessage('Error: All checkpoints must have at least one criteria');
                setShowToast(true);
            }

            if (pipelineData.some(checkpoint => checkpoint.criteria.some(criteria => !criteria.criteriaName || criteria.criteriaValue.length === 0))) {
                setToastMessage('Error: All criteria must have a name and at least one value');
                setShowToast(true);
            }

            if (pipelineData.some(checkpoint => checkpoint.criteria.some(criteria => criteria.criteriaValue.some(value => !value.id || !value.name)))) {
                setToastMessage('Error: All criteria values must have an ID and a name');
                setShowToast(true);
            }

            if (action === 'edit') {
                response = await updatePipeline(
                    db, auth.currentUser, { value: pipelineName, discription: pipelineDescription, pipeline: pipelineData }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addPipeline(
                    db, auth.currentUser, { value: pipelineName, discription: pipelineDescription, pipeline: pipelineData }
                );
            }
        } else if (title === 'Filter Button') {
            if (!filterButtonName) {
                setToastMessage('Error: Filter button name is required');
                setShowToast(true);
                setIsUpdating(false);
                return;
            }

            if (action === 'edit') {
                response = await updateFilterButton(
                    db, auth.currentUser, { value: filterButtonName, discription: filterButtonDescription, color: filterButtonColor, filterButton: formData?.filterButton }, data?.[0]?.id ?? ''
                );
            } else {
                response = await addFilterButton(
                    db, auth.currentUser, { value: filterButtonName, discription: filterButtonDescription, color: filterButtonColor, filterButton: formData?.filterButton }
                );
            }
        }
        setIsUpdating(false);

        if (response?.success) {
            onClose(response?.message);
        } else {
            alert(response?.message);
        }
    };

    const mergeAndUpdateArrays = <T extends Record<string, any>>(
        existingArray: T[],
        newArray: T[],
        keyField: keyof T
    ): T[] => {
        const newItemsMap = new Map(newArray.map(item => [item[keyField], item]));

        // Update existing items with server data if they exist, otherwise keep original
        const updatedExisting = existingArray.map(item =>
            newItemsMap.has(item[keyField]) ? { ...item, ...newItemsMap.get(item[keyField]) } : item
        );

        // Add any new items from server that don't exist in existing array
        const existingKeys = new Set(existingArray.map(item => item[keyField]));
        const newItems = newArray.filter(item => !existingKeys.has(item[keyField]));

        return [...updatedExisting, ...newItems];
    };

    const handleActionEdit = (data: any) => {
        console.log('Handling action edit with data:', data.sub);

        if (title === 'Campaigns') {
            setFormData({
                ...formData,
                campaign: data?.data?.campaign
            });
        } else if (title === 'Lead Sources') {
            setFormData({
                ...formData,
                source: data?.data?.source,
                subSources: data?.sub?.map((sub: any) => ({
                    id: sub.id,
                    subSource: sub.data.subSource
                })) || []
            });
        } else if (title === 'Lead Stages') {
            setFormData({
                ...formData,
                stage: data?.data?.stage,
                priority: data?.data?.priority,
                color: data?.data?.color,
                subStages: data?.sub?.map((sub: any) => ({
                    id: sub.id,
                    subStage: sub.data.subStage
                })) || []
            });
        } else if (title === 'Lead States') {
            setFormData({
                ...formData,
                states: data?.data?.state,
                color: data?.data?.color,
            });
        } else if (title === 'Lead Status') {
            setFormData({
                ...formData,
                status: data?.data?.status,
                priority: data?.data?.priority,
                color: data?.data?.color,
                subStatuses: data?.sub?.map((sub: any) => ({
                    id: sub.id,
                    subStatus: sub.data.subStatus
                })) || []
            });
        } else if (title === 'Admission Status') {
            setFormData({
                ...formData,
                admissionStatus: data?.data?.admissionStatus,
                level: data?.data?.level,
                subAdmissionStatus: data?.sub?.map((sub: any) => ({
                    id: sub.id,
                    subAdmissionStatus: sub.data.subAdmissionStatus
                })) || []
            });
        } else if (title === 'Welcome Call Status') {
            setFormData({
                ...formData,
                welcomeCallByAdmissionTeamStatus: data?.data?.welcomeCallByAdmissionTeamStatus
            });
        } else if (title === 'Visa Processing') {
            setFormData({
                ...formData,
                visaFileProcessingStatus: data?.data?.visaFileProcessingStatus
            });
        } else if (title === 'Application Status') {
            setFormData({
                ...formData,
                applicationMovedStatus: data?.data?.applicationMovedStatus
            });
        } else if (title === 'Offer Letter Status') {
            setFormData({
                ...formData,
                offerLetterStatus: data?.data?.offerLetterStatus
            });
        } else if (title === 'Fee Payment Status') {
            setFormData({
                ...formData,
                feePaymentStatus: data?.data?.feePaymentStatus
            });
        } else if (title === 'File Submission Status') {
            setFormData({
                ...formData,
                fileSubmissionStatus: data?.data?.fileSubmissionStatus
            });
        } else if (title === 'Registration fees') {
            setFormData({
                ...formData,
                registrationFeeDetails: {
                    registrationFeeName: data?.data?.registrationFeeName || '',
                    registrationFeeAmount: data?.data?.registrationFeeAmount || ''
                }
            });
        } else if (title === 'Document Categories') {
            setFormData({
                ...formData,
                documentCategory: {
                    categoryName: data?.data?.categoryName || '',
                    documentValues: data?.data?.documentValues || []
                }
            });
        } else if (title === 'Preffered Stream') {
            setFormData({
                ...formData,
                prefferedStream: data?.data?.preferredStream,
            });
        } else if (title === 'Program Type') {
            setFormData({
                ...formData,
                programType: data?.data?.programType,
            });
        } else if (title === 'Super Agent') {
            setFormData({
                ...formData,
                superAgent: data?.data?.superAgent,
            });
        } else if (title === 'Languages') {
            setFormData({
                ...formData,
                language: data?.data?.language,
            });
        } else if (title === 'Departments') {
            setFormData({
                ...formData,
                department: data?.data?.department,
                selectedFilterIds: Array.isArray(data?.data?.selectedFilterIds) ? [...data.data.selectedFilterIds] : [],

                tabPermissions: Array.isArray(data?.data?.tabPermissions)
                    ? mergeAndUpdateArrays(formData.tabPermissions, data.data.tabPermissions, 'name')
                    : [...formData.tabPermissions],

                actionPermission: Array.isArray(data?.data?.actionPermission)
                    ? mergeAndUpdateArrays(formData.actionPermission, data.data.actionPermission, 'name')
                    : [...formData.actionPermission],

                bulkActionPermission: Array.isArray(data?.data?.bulkActionPermission)
                    ? mergeAndUpdateArrays(formData.bulkActionPermission, data.data.bulkActionPermission, 'id')
                    : [...formData.bulkActionPermission],

                sidebarItems: Array.isArray(data?.data?.sidebarNavigation)
                    ? mergeAndUpdateArrays(formData.sidebarItems, data.data.sidebarNavigation, 'id')
                    : [...formData.sidebarItems]
            });
        } else if (title === 'Affiliate Departments') {
            setFormData({
                ...formData,
                department: data?.data?.department,

                tabPermissions: Array.isArray(data?.data?.tabPermissions)
                    ? mergeAndUpdateArrays(formData.tabPermissions, data.data.tabPermissions, 'name')
                    : [...formData.tabPermissions],

                actionPermission: Array.isArray(data?.data?.actionPermission)
                    ? mergeAndUpdateArrays(formData.actionPermission, data.data.actionPermission, 'name')
                    : [...formData.actionPermission],

                sidebarItems: Array.isArray(data?.data?.sidebarNavigation)
                    ? mergeAndUpdateArrays(formData.sidebarItems, data.data.sidebarNavigation, 'id')
                    : [...formData.sidebarItems]
            });
        } else if (title === 'Pipeline') {
            setPipelineName(data?.data?.pipelineName || '');
            setPipelineDescription(data?.data?.pipelineDescription || '');
            setPipelineData(Array.isArray(data?.data?.checkpoints)
                ? [...data.data.checkpoints]
                : []);
        } else if (title === 'Filter Button') {
            setFilterButtonName(data?.data?.name || '');
            setFilterButtonDescription(data?.data?.description || '');
            setFilterButtonColor(data?.data?.color || '#000000');
            setFormData({
                ...formData,
                filterButton: {
                    sourceIds: data?.data?.filterButton?.sourceIds || [],
                    stageIds: data?.data?.filterButton?.stageIds || [],
                    stateIds: data?.data?.filterButton?.stateIds || [],
                    statusIds: data?.data?.filterButton?.statusIds || [],
                    admissionStatusIds: data?.data?.filterButton?.admissionStatusIds || [],
                    welcomeCallStatusIds: data?.data?.filterButton?.welcomeCallStatusIds || [],
                    visaProcessingStatusIds: data?.data?.filterButton?.visaProcessingStatusIds || [],
                    applicationStatusIds: data?.data?.filterButton?.applicationStatusIds || [],
                    conditionalOfferLetterStatusIds: data?.data?.filterButton?.conditionalOfferLetterStatusIds || [],
                    unconditionalOfferLetterStatusIds: data?.data?.filterButton?.unconditionalOfferLetterStatusIds || [],
                    feePaymentStatusIds: data?.data?.filterButton?.feePaymentStatusIds || [],
                    fileSubmissionStatusIds: data?.data?.filterButton?.fileSubmissionStatusIds || [],
                    preferredStreamIds: data?.data?.filterButton?.preferredStreamIds || [],
                    assigneeIds: data?.data?.filterButton?.assigneeIds || [],
                    subAgentIds: data?.data?.filterButton?.subAgentIds || [],
                    superAgentIds: data?.data?.filterButton?.superAgentIds || [],
                    followUpIds: data?.data?.filterButton?.followUpIds || [],
                    campaignIds: data?.data?.filterButton?.campaignIds || [],
                    destinationIds: data?.data?.filterButton?.destinationIds || [],
                    followUpStatus: data?.data?.filterButton?.followUpStatus || [],
                    // subSourceIds: [],
                    // subStatusIds: [],
                    // admissionSubStatusIds: []
                }
            });
        }
    };


    const [filterButtonName, setFilterButtonName] = useState('');
    const [filterButtonDescription, setFilterButtonDescription] = useState('');
    const [filterButtonColor, setFilterButtonColor] = useState('#00000');
    const [searchQuery, setSearchQuery] = useState('');
    const [admissionStatuses, setAdmissionStatuses] = useState<DocumentWithId[]>([]);
    const [leadSubAdmissionStatuses, setLeadSubAdmissionStatuses] = useState<DocumentWithId[]>([]);
    const [leadSources, setLeadSources] = useState<DocumentWithId[]>([]);
    const [leadSubSources, setLeadSubSources] = useState<DocumentWithId[]>([]);
    const [leadStages, setLeadStages] = useState<DocumentWithId[]>([]);
    const [leadSubStages, setLeadSubStages] = useState<DocumentWithId[]>([]);
    const [leadSubStatuses, setLeadSubStatuses] = useState<DocumentWithId[]>([]);
    const [leadStates, setLeadStates] = useState<DocumentWithId[]>([]);
    const [leadStatuses, setLeadStatuses] = useState<DocumentWithId[]>([]);
    const [welcomeCallByAdmissionTeamStatuses, setWelcomeCallByAdmissionTeamStatuses] = useState<DocumentWithId[]>([]);
    const [visaProcessingStatuses, setVisaProcessingStatuses] = useState<DocumentWithId[]>([]);
    const [applicationMovedStatuses, setApplicationMovedStatuses] = useState<DocumentWithId[]>([]);
    const [offerLetterStatuses, setOfferLetterStatuses] = useState<DocumentWithId[]>([]);
    const [feePaymentStatuses, setFeePaymentStatuses] = useState<DocumentWithId[]>([]);
    const [fileSubmissionStatuses, setFileSubmissionStatuses] = useState<DocumentWithId[]>([]);
    const [campaigns, setCampaigns] = useState<DocumentWithId[]>([]);
    const [preferredStreams, setPreferredStreams] = useState<DocumentWithId[]>([]);
    const [users, setUsers] = useState<DocumentWithId[]>([]);
    const [subAgents, setSubAgents] = useState<DocumentWithId[]>([]);
    const [superAgents, setSuperAgents] = useState<DocumentWithId[]>([]);
    const [destinations, setDestinations] = useState<DocumentWithId[]>([]);
    const [registrationFeeDetails, setRegistrationFeeDetails] = useState<DocumentWithId[]>([]);

    const [checkBoxActive, setCheckBoxActive] = useState(false);

    const fetchData = async () => {
        try {
            if (userData?.companyId) {
                // Fetch admission statuses
                const admissionStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadAdmissionStatus`));
                const leadSubAdmissionStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadAdmissionSubStatus`));
                setAdmissionStatuses(admissionStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadAdmissionStatus
                }))
                    .sort((a, b) => {
                        return a.data.level - b.data.level;
                    })
                );
                setLeadSubAdmissionStatuses(leadSubAdmissionStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadSubAdmissionStatus
                })));

                // Fetch lead sources
                const leadSourcesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadSources`));
                setLeadSources(
                    leadSourcesSnapshot.docs
                        .map(doc => ({
                            id: doc.id,
                            data: doc.data() as LeadSource
                        }))
                        .sort((a, b) => a.data.source.localeCompare(b.data.source))
                );;

                const leadSubSourcesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadSubSources`));
                setLeadSubSources(leadSubSourcesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadSubSource
                }))
                    .sort((a, b) => a.data.subSource.localeCompare(b.data.subSource))
                );

                // Fetch lead stages
                const leadStagesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadStages`));
                const leadSubStagesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadSubStages`));
                setLeadStages(leadStagesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadStage
                }))
                    .sort((a, b) => {
                        return a.data.priority - b.data.priority;
                    })
                );
                setLeadSubStages(leadSubStagesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadSubStage
                })));

                // Fetch lead states
                const leadStatesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadStates`));
                setLeadStates(
                    leadStatesSnapshot.docs
                        .map(doc => ({
                            id: doc.id,
                            data: doc.data() as LeadState
                        }))
                        .sort((a, b) => a.data.state.localeCompare(b.data.state))
                );

                // Fetch lead statuses
                const leadStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadStatuses`));
                const leadSubStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadSubStatuses`));
                setLeadStatuses(leadStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadStatus
                }))
                    .sort((a, b) => {
                        return a.data.priority - b.data.priority;
                    })
                );
                setLeadSubStatuses(leadSubStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadSubStatus
                })));

                // Fetch welcome call statuses
                const welcomeCallByAdmissionTeamStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadWelcomeCallByAdmissionTeamStatus`));
                setWelcomeCallByAdmissionTeamStatuses(welcomeCallByAdmissionTeamStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadWelcomeCallByAdmissionTeamStatus
                }))
                    .sort((a, b) => a.data.welcomeCallByAdmissionTeamStatus?.localeCompare(b.data.welcomeCallByAdmissionTeamStatus))
                );

                // Fetch visa processing statuses
                const visaProcessingStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadVisaFileProcessingStatus`));
                setVisaProcessingStatuses(visaProcessingStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadVisaFileProcessingStatus
                }))
                    .sort((a, b) => a.data.visaFileProcessingStatus?.localeCompare(b.data.visaFileProcessingStatus))
                );

                // Fetch application moved statuses
                const applicationMovedStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadApplicationMovedStatus`));
                setApplicationMovedStatuses(applicationMovedStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadApplicationMovedStatus
                }))
                    .sort((a, b) => a.data.applicationMovedStatus?.localeCompare(b.data.applicationMovedStatus))
                );

                // Fetch offer letter statuses
                const offerLetterStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadOfferLetterStatus`));
                setOfferLetterStatuses(offerLetterStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadOfferLetterStatus
                }))
                    .sort((a, b) => a.data.offerLetterStatus?.localeCompare(b.data.offerLetterStatus))
                );

                // Fetch fee payment statuses
                const feePaymentStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadFeePaymentStatus`));
                setFeePaymentStatuses(feePaymentStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadFeePaymentStatus
                }))
                    .sort((a, b) => a.data.feePaymentStatus?.localeCompare(b.data.feePaymentStatus))
                );

                // Fetch registration fee details
                const registrationFeeDetailsSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/registrationFeeDetails`));
                setRegistrationFeeDetails(registrationFeeDetailsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as RegistrationFeeDetails
                }))
                    .sort((a, b) => a.data.registrationFeeDetails?.localeCompare(b.data.registrationFeeDetails))
                );


                // Fetch file submission statuses
                const fileSubmissionStatusesSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadFileSubmissionStatus`));
                setFileSubmissionStatuses(fileSubmissionStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadFileSubmissionStatus
                }))
                    .sort((a, b) => a.data.fileSubmissionStatus?.localeCompare(b.data.fileSubmissionStatus))
                );

                const companyCampaignsSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/leadCampaigns`));
                setCampaigns(companyCampaignsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadCampaigns
                }))
                    .sort((a, b) => a.data.campaign?.localeCompare(b.data.campaign))
                );

                const preferredStreamsSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/preferredStreams`));
                setPreferredStreams(preferredStreamsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as PreferredStreams
                }))
                    .sort((a, b) => a.data.preferredStream?.localeCompare(b.data.preferredStream))
                );

                const superAgentsSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/superAgents`));
                setSuperAgents(superAgentsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }))
                    .sort((a, b) => a.data.superAgent?.localeCompare(b.data.superAgent))
                );

                const subAgentsSnapshot = await getDocs(collection(db, `companies/${userData.companyId}/subAgents`));
                setSubAgents(subAgentsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }))
                    .sort((a, b) => a.data.name?.localeCompare(b.data.name))
                );

                const usersQuery = query(
                    collection(db, `users`),
                    where('companyId', '==', userData.companyId),
                );
                const usersSnapshot = await getDocs(usersQuery);
                setUsers(usersSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }))
                    .sort((a, b) => a.data.name?.localeCompare(b.data.name))
                );

                const destinationSnapshot = await getDocs(collection(db, `countries`));
                setDestinations(destinationSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }))
                    .sort((a, b) => a.data.name?.localeCompare(b.data.name))
                );

            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    React.useEffect(() => {
        if (!userData?.companyId) return;
        if (title === 'Filter Button') {
            fetchData();
        }
    }, [userData?.companyId, title]);

    const filterItems = (items: DocumentWithId[], getDisplayText: (item: any) => string) => {
        if (!searchQuery) return items;
        return items.filter(item =>
            getDisplayText(item.data).toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    // const handleCheckBoxChange = (
    //     item: DocumentWithId,
    //     title: string,
    // ) => {
    //     switch (title) {
    //         case 'Campaigns':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     campaignIds: prev.filterButton.campaignIds.includes(item.id)
    //                         ? prev.filterButton.campaignIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.campaignIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Lead Sources':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     sourceIds: prev.filterButton.sourceIds.includes(item.id)
    //                         ? prev.filterButton.sourceIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.sourceIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Admission Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     admissionStatusIds: prev.filterButton.admissionStatusIds.includes(item.id)
    //                         ? prev.filterButton.admissionStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.admissionStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Welcome Call Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     welcomeCallStatusIds: prev.filterButton.welcomeCallStatusIds.includes(item.id)
    //                         ? prev.filterButton.welcomeCallStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.welcomeCallStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Visa Processing':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     visaProcessingStatusIds: prev.filterButton.visaProcessingStatusIds.includes(item.id)
    //                         ? prev.filterButton.visaProcessingStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.visaProcessingStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Application Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     applicationStatusIds: prev.filterButton.applicationStatusIds.includes(item.id)
    //                         ? prev.filterButton.applicationStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.applicationStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Conditional Offer Letter Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     conditionalOfferLetterStatusIds: prev.filterButton.conditionalOfferLetterStatusIds.includes(item.id)
    //                         ? prev.filterButton.conditionalOfferLetterStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.conditionalOfferLetterStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Unonditional Offer Letter Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     unconditionalOfferLetterStatusIds: prev.filterButton.unconditionalOfferLetterStatusIds.includes(item.id)
    //                         ? prev.filterButton.unconditionalOfferLetterStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.unconditionalOfferLetterStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Fee Payment Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     feePaymentStatusIds: prev.filterButton.feePaymentStatusIds.includes(item.id)
    //                         ? prev.filterButton.feePaymentStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.feePaymentStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'File Submission Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     fileSubmissionStatusIds: prev.filterButton.fileSubmissionStatusIds.includes(item.id)
    //                         ? prev.filterButton.fileSubmissionStatusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.fileSubmissionStatusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Lead Stages':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     leadStageIds: prev.filterButton.stageIds.includes(item.id)
    //                         ? prev.filterButton.stageIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.stageIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Lead States':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     stateIds: prev.filterButton.stateIds.includes(item.id)
    //                         ? prev.filterButton.stateIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.stateIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Lead Status':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     statusIds: prev.filterButton.statusIds.includes(item.id)
    //                         ? prev.filterButton.statusIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.statusIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Preferred Stream':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     preferredStreamIds: prev.filterButton.preferredStreamIds.includes(item.id)
    //                         ? prev.filterButton.preferredStreamIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.preferredStreamIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Assignees':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     assigneeIds: prev.filterButton.assigneeIds.includes(item.id)
    //                         ? prev.filterButton.assigneeIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.assigneeIds, item.id]
    //                 }
    //             }));
    //             break;
    //         case 'Super Agent':
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 filterButton: {
    //                     ...prev.filterButton,
    //                     superAgentIds: prev.filterButton.superAgentIds.includes(item.id)
    //                         ? prev.filterButton.superAgentIds.filter(id => id !== item.id)
    //                         : [...prev.filterButton.superAgentIds, item.id]
    //                 }
    //             }));
    //             break;
    //         default:
    //             console.warn(`Unhandled checkbox title: ${title}`);
    //             break;
    //     }
    // }

    // Define the mapping between titles and their corresponding field names
    const FILTER_FIELD_MAPPING = {
        'Campaigns': 'campaignIds',
        'Lead Sources': 'sourceIds',
        'Admission Status': 'admissionStatusIds',
        'Welcome Call Status': 'welcomeCallStatusIds',
        'Visa Processing': 'visaProcessingStatusIds',
        'Application Status': 'applicationStatusIds',
        'Conditional Offer Letter Status': 'conditionalOfferLetterStatusIds',
        'Unonditional Offer Letter Status': 'unconditionalOfferLetterStatusIds', // Note: typo preserved from original
        'Fee Payment Status': 'feePaymentStatusIds',
        'File Submission Status': 'fileSubmissionStatusIds',
        'Lead Stages': 'stageIds', // Fixed: was using leadStageIds in state but stageIds in logic
        'Lead States': 'stateIds',
        'Lead Status': 'statusIds',
        'Preferred Stream': 'preferredStreamIds',
        'Assignees': 'assigneeIds',
        'Sub Agents': 'subAgentIds',
        'Super Agent': 'superAgentIds',
        'Destinations': 'destinationIds',
        'Follow Up Status': 'followUpStatus',
    } as const;

    // Type for the filter field names
    type FilterFieldName = typeof FILTER_FIELD_MAPPING[keyof typeof FILTER_FIELD_MAPPING];

    // Helper function to toggle an ID in an array
    const toggleIdInArray = (ids: string[], targetId: string): string[] => {
        return ids.includes(targetId)
            ? ids.filter(id => id !== targetId)
            : [...ids, targetId];
    };

    // Optimized handler function
    const handleCheckBoxChange = (item: DocumentWithId, title: string) => {
        const fieldName = FILTER_FIELD_MAPPING[title as keyof typeof FILTER_FIELD_MAPPING];

        if (!fieldName) {
            console.warn(`Unhandled checkbox title: ${title}`);
            return;
        }

        setFormData(prev => ({
            ...prev,
            filterButton: {
                ...prev.filterButton,
                [fieldName]: toggleIdInArray(prev.filterButton[fieldName], item.id)
            }
        }));
    };

    // Helper function to get field name from title
    const getFieldNameFromTitle = (title: string) => {
        return FILTER_FIELD_MAPPING[title as keyof typeof FILTER_FIELD_MAPPING];
    };

    const renderSettingsCheckBox = (
        title: string,
        items: DocumentWithId[],
        // selectedItems: string[],
        setSelectedItems: string[],
        getDisplayText: (item: any) => string,
        getColor?: (item: any) => string | undefined,
        getLevel?: (item: any) => number
    ) => {
        // Get the correct field name for this title
        const fieldName = getFieldNameFromTitle(title);

        if (!fieldName) {
            console.warn(`No field mapping found for title: ${title}`);
            return null;
        }

        return (
            <div className="flex flex-col bg-white rounded-lg shadow-sm">
                <div className="bg-gray-50 px-4 py-2 rounded-t-lg">
                    <h3 className="text-sm font-semibold font-Montserrat text-gray-700">
                        {title}
                    </h3>
                </div>
                <div className="bg-white p-3 rounded-b-lg h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                    <div className="space-y-2">
                        {filterItems(items, getDisplayText).map((item) => (
                            <div
                                key={item.id}
                                className="flex justify-between items-center hover:bg-gray-50 p-1 rounded transition-colors"
                                title={getDisplayText(item.data)}
                            >
                                <span
                                    className="text-sm font-Montserrat text-gray-600 truncate"
                                    style={getColor ? { color: getColor(item.data) } : undefined}
                                >
                                    {getDisplayText(item.data)}
                                </span>

                                <div className='flex items-center gap-2'>
                                    {/* check box */}
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        checked={formData?.filterButton?.[fieldName]?.includes(item.id) ?? false}
                                        onChange={() => {
                                            handleCheckBoxChange(item, title);
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    const getTabContent = () => {
        return (
            <div className="grid grid-cols-3 gap-4">
                {renderSettingsCheckBox(
                    'Campaigns',
                    campaigns,
                    formData?.filterButton?.campaignIds || [],
                    (item: Campaign) => item.campaign
                )}
                {renderSettingsCheckBox(
                    'Lead Sources',
                    leadSources,
                    formData?.filterButton?.sourceIds || [],
                    (item: LeadSource) => item.source
                )}
                {renderSettingsCheckBox(
                    'Admission Status',
                    admissionStatuses,
                    formData?.filterButton?.admissionStatusIds || [],
                    (item: LeadAdmissionStatus) => item.admissionStatus,
                )}
                {renderSettingsCheckBox(
                    'Welcome Call Status',
                    welcomeCallByAdmissionTeamStatuses,
                    formData?.filterButton?.welcomeCallStatusIds || [],
                    (item: LeadWelcomeCallByAdmissionTeamStatus) => item.welcomeCallByAdmissionTeamStatus
                )}
                {renderSettingsCheckBox(
                    'Visa Processing',
                    visaProcessingStatuses,
                    formData?.filterButton?.visaProcessingStatusIds || [],
                    (item: LeadVisaFileProcessingStatus) => item.visaFileProcessingStatus
                )}
                {renderSettingsCheckBox(
                    'Application Status',
                    applicationMovedStatuses,
                    formData?.filterButton?.applicationStatusIds || [],
                    (item: LeadApplicationMovedStatus) => item.applicationMovedStatus
                )}
                {renderSettingsCheckBox(
                    'Conditional Offer Letter Status',
                    offerLetterStatuses,
                    formData?.filterButton?.conditionalOfferLetterStatusIds || [],
                    (item: LeadOfferLetterStatus) => item.offerLetterStatus
                )}
                {renderSettingsCheckBox(
                    'Unonditional Offer Letter Status',
                    offerLetterStatuses,
                    formData?.filterButton?.unconditionalOfferLetterStatusIds || [],
                    (item: LeadOfferLetterStatus) => item.offerLetterStatus
                )}
                {renderSettingsCheckBox(
                    'Fee Payment Status',
                    feePaymentStatuses,
                    formData?.filterButton?.feePaymentStatusIds || [],
                    (item: LeadFeePaymentStatus) => item.feePaymentStatus,
                )}
                {renderSettingsCheckBox(
                    'File Submission Status',
                    fileSubmissionStatuses,
                    formData?.filterButton?.fileSubmissionStatusIds || [],
                    (item: LeadFileSubmissionStatus) => item.fileSubmissionStatus,
                )}
                {renderSettingsCheckBox(
                    'Lead Stages',
                    leadStages,
                    formData?.filterButton?.stageIds || [],
                    (item: LeadStage) => item.stage,
                )}
                {renderSettingsCheckBox(
                    'Lead States',
                    leadStates,
                    formData?.filterButton?.stateIds || [],
                    (item: LeadState) => item.state,
                )}
                {renderSettingsCheckBox(
                    'Lead Status',
                    leadStatuses,
                    formData?.filterButton?.statusIds || [],
                    (item: LeadStatus) => item.status,
                )}
                {renderSettingsCheckBox(
                    'Preferred Stream',
                    preferredStreams,
                    formData?.filterButton?.preferredStreamIds || [],
                    (item: PreferredStreams) => item.preferredStream
                )}
                {renderSettingsCheckBox(
                    'Assignees',
                    users,
                    formData?.filterButton?.assigneeIds || [],
                    (item: Users) => item.name
                )}
                {renderSettingsCheckBox(
                    'Super Agent',
                    superAgents,
                    formData?.filterButton?.superAgentIds || [],
                    (item: SuperAgent) => item.superAgent
                )}
                {renderSettingsCheckBox(
                    'Sub Agents',
                    subAgents,
                    formData?.filterButton?.subAgentIds || [],
                    (item: SubAgent) => item.name
                )}
                {renderSettingsCheckBox(
                    'Destinations',
                    destinations,
                    formData?.filterButton?.destinationIds || [],
                    (item: Destinations) => item.name
                )}
                {renderSettingsCheckBox(
                    'Follow Up Status',
                    [{ id: 'true', data: { name: 'True' } }, { id: 'false', data: { name: 'False' } }],
                    formData?.filterButton?.followUpStatus || [],
                    (item) => item.name
                )}
            </div>
        );

    }


    // UseEffect to toogle the checkbox state based on the length of all the array in the filterButton is equal to 30
    React.useEffect(() => {
        // console.log('Filter Button Data:', formData.filterButton);
        // console.log(Object.values(formData.filterButton).some(ids => ids.length >= 30));
        // console.log('Total Length:', Object.values(formData.filterButton).reduce((acc, curr) => acc + curr.length, 0));
        // console.log('Total Combinations of all arrays:', Object.values(formData.filterButton).filter(arr => arr.length > 0).reduce((acc, curr) => acc * curr.length, 1));
        if (Object.values(formData.filterButton).filter(arr => arr.length > 0).reduce((acc, curr) => acc * curr.length, 1) > 30) {
            setCheckBoxActive(true);
        } else {
            setCheckBoxActive(false);
        }
    }, [formData.filterButton]);

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-3xl w-[90%] h-[75%] md:w-[70%] lg:w-[50%] overflow-y-auto relative ">
                <div className="top-0 left-0 right-0 h-[40px] flex items-center justify-between rounded-tl-[12px] rounded-tr-[12px] p-4">
                    <div className="flex items-center gap-4">
                        <div className="w-14 h-14 p-2 rounded-full bg-gradient-to-b from-[#00A6D9] to-[#3483BE] flex items-center justify-center">
                            <img src={`${process.env.PUBLIC_URL}/images/desktop/sidebaricon/report-svgrepo-com-white.svg`} alt="Lead Icon" />
                        </div>
                        <h2 className="text-xl font-semibold text-black">{title}</h2>
                    </div>
                    <button
                        onClick={() => onClose('')}
                        className="absolute top-4 right-4 font-semibold text-3xl"
                        style={{ background: 'linear-gradient(270deg, #A7C8E7 0%, #00A6D9 100%)', WebkitBackgroundClip: 'text', color: 'transparent' }}
                    >
                        <img src={`${process.env.PUBLIC_URL}/images/desktop/close-btn.svg`} alt="Close" className="w-6 h-6" />
                    </button>
                </div>

                <form
                    onSubmit={handleSubmit}
                >
                    <div className="grid grid-cols-1 gap-6 mt-8">
                        {title === 'Campaigns' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Campaign</label>
                                <input
                                    type="text"
                                    name="campaign"
                                    value={formData.campaign.toLocaleUpperCase()}
                                    onChange={handleInputChange}
                                    placeholder='Enter Campaign Name'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Lead Sources' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Lead Source</label>
                                <input
                                    type="text"
                                    name="source"
                                    value={formData.source}
                                    onChange={handleInputChange}
                                    placeholder='Enter Lead Source'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                                {formData.subSources.length < 1 && (
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, subSources: [{ id: '', subSource: '' }] })}
                                        className="mt-2 text-blue-500 hover:text-blue-700"
                                    >
                                        Need Sub Sources ? Click Here
                                    </button>
                                )}

                                {/* Sub sources */}
                                {formData.subSources.length > 0 && (
                                    <div className="mt-4 flex items-center gap-2">
                                        <label className="block text-sm font-medium text-gray-700">Sub Sources</label>
                                        <button
                                            type="button"
                                            onClick={() => setFormData({ ...formData, subSources: [...formData.subSources, { id: '', subSource: '' }] })}
                                            className="text-xs text-blue-500 hover:text-blue-700 border border-blue-500 px-2 py-0.5 rounded-lg"
                                        >
                                            Add Sub Source
                                        </button>
                                    </div>
                                )}
                                {formData.subSources.map((subSource, index) => (
                                    <div key={index} className="flex items-center gap-2">
                                        {/* <label className="block text-lg font-medium text-gray-700">{index + 1}</label> */}
                                        <input
                                            type="text"
                                            name={`subSource-${index}`}
                                            value={subSource.subSource}
                                            onChange={(e) => {
                                                const newSubSources = [...formData.subSources];
                                                newSubSources[index].subSource = e.target.value;
                                                setFormData({ ...formData, subSources: newSubSources });
                                            }}
                                            placeholder='Enter Sub Source'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const newSubSources = formData.subSources.filter((_, i) => i !== index);
                                                setFormData({ ...formData, subSources: newSubSources });
                                            }}
                                            className="mt-2 text-red-500 hover:text-red-700"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                        {title === 'Lead Stages' && (
                            <div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Lead Stage <span className="text-red-500">*</span></label>
                                        <input
                                            type="text"
                                            name="stage"
                                            value={formData.stage}
                                            onChange={handleInputChange}
                                            placeholder='Enter Lead Stage'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">
                                            Priority <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="priority"
                                            value={formData.priority}
                                            onChange={handleInputChange}
                                            placeholder='Enter Priority (required)'
                                            className={`w-full p-2 border rounded-md mt-2 transition-colors ${priorityError
                                                ? 'border-red-500 bg-red-50 focus:border-red-500 focus:ring-red-200'
                                                : 'focus:border-blue-500 focus:ring-blue-200'
                                                }`}
                                            style={{
                                                borderRadius: '24px',
                                                border: priorityError ? '2px solid #EF4444' : '1px solid #3483BE'
                                            }}
                                            required
                                        />
                                        {priorityError && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                Priority is required
                                            </p>
                                        )}
                                    </div>
                                    {/* Color picker */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Color</label>
                                        <input
                                            type="text"
                                            name="color"
                                            value={formData.color.toLocaleUpperCase()}
                                            onChange={handleInputChange}
                                            placeholder='Enter or Select Color'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Color Picker</label>
                                        <input
                                            type="color"
                                            name="color"
                                            value={formData.color}
                                            onChange={handleInputChange}
                                            className="appearance-none bg-transparent w-[40%] h-[40px] border-none outline-none cursor-pointer rounded-xl mt-2"
                                        />
                                    </div>
                                </div>

                                {/* Sub Stages */}
                                {formData.subStages.length < 1 && (
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, subStages: [{ id: '', subStage: '' }] })}
                                        className="mt-2 text-blue-500 hover:text-blue-700"
                                    >
                                        Need Sub Stages ? Click Here
                                    </button>
                                )}

                                {formData.subStages.length > 0 && (
                                    <div className="mt-4 flex items-center gap-2">
                                        <label className="block text-sm font-medium text-gray-700">Sub Stages</label>
                                        <button
                                            type="button"
                                            onClick={() => setFormData({ ...formData, subStages: [...formData.subStages, { id: '', subStage: '' }] })}
                                            className="text-xs text-blue-500 hover:text-blue-700 border border-blue-500 px-2 py-0.5 rounded-lg"
                                        >
                                            Add Sub Stage
                                        </button>
                                    </div>
                                )}

                                {formData.subStages.map((subStage, index) => (
                                    <div key={index} className="flex items-center gap-2">
                                        {/* <label className="block text-lg font-medium text-gray-700">{index + 1}</label> */}
                                        <input
                                            type="text"
                                            name={`subStage-${index}`}
                                            value={subStage.subStage}
                                            onChange={(e) => {
                                                const newSubStages = [...formData.subStages];
                                                newSubStages[index].subStage = e.target.value;
                                                setFormData({ ...formData, subStages: newSubStages });
                                            }}
                                            placeholder='Enter Sub Stage'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const newSubStages = formData.subStages.filter((_, i) => i !== index);
                                                setFormData({ ...formData, subStages: newSubStages });
                                            }}
                                            className="mt-2 text-red-500 hover:text-red-700"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                        {title === 'Lead States' && (
                            <div className="grid grid-cols-1 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Lead State</label>
                                    <input
                                        type="text"
                                        name="states"
                                        value={formData.states}
                                        onChange={handleInputChange}
                                        placeholder='Enter Lead State'
                                        className="w-full p-2 border rounded-md mt-2"
                                        style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    />
                                </div>
                                {/* Color picker */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Color</label>
                                        <input
                                            type="text"
                                            name="color"
                                            value={formData.color.toLocaleUpperCase()}
                                            onChange={handleInputChange}
                                            placeholder='Enter or Select Color'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Color Picker</label>
                                        <input
                                            type="color"
                                            name="color"
                                            value={formData.color}
                                            onChange={handleInputChange}
                                            className="appearance-none bg-transparent w-full h-[40px] border-none outline-none  cursor-pointer rounded-xl mt-2"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {title === 'Lead Status' && (
                            <div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Lead Status</label>
                                        <input
                                            type="text"
                                            name="status"
                                            value={formData.status}
                                            onChange={handleInputChange}
                                            placeholder='Enter Lead Status'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">
                                            Priority <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="priority"
                                            value={formData.priority}
                                            onChange={handleInputChange}
                                            placeholder='Enter Priority (required)'
                                            className={`w-full p-2 border rounded-md mt-2 transition-colors ${priorityError
                                                ? 'border-red-500 bg-red-50 focus:border-red-500 focus:ring-red-200'
                                                : 'focus:border-blue-500 focus:ring-blue-200'
                                                }`}
                                            style={{
                                                borderRadius: '24px',
                                                border: priorityError ? '2px solid #EF4444' : '1px solid #3483BE'
                                            }}
                                            required
                                        />
                                        {priorityError && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                Priority is required
                                            </p>
                                        )}
                                    </div>
                                    {/* Color picker */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Color</label>
                                        <input
                                            type="text"
                                            name="color"
                                            value={formData.color.toLocaleUpperCase()}
                                            onChange={handleInputChange}
                                            placeholder='Enter or Select Color'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Color Picker</label>
                                        <input
                                            type="color"
                                            name="color"
                                            value={formData.color}
                                            onChange={handleInputChange}
                                            className="appearance-none bg-transparent w-[40%] h-[40px] border-none outline-none cursor-pointer rounded-xl mt-2"
                                        />
                                    </div>
                                </div>

                                {/* Sub Status */}
                                {formData.subStatuses.length < 1 && (
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, subStatuses: [{ id: '', subStatus: '' }] })}
                                        className="mt-2 text-blue-500 hover:text-blue-700"
                                    >
                                        Need Sub Status ? Click Here
                                    </button>
                                )}

                                {formData.subStatuses.length > 0 && (
                                    <div className="mt-4 flex items-center gap-2">
                                        <label className="block text-sm font-medium text-gray-700">Sub Status</label>
                                        <button
                                            type="button"
                                            onClick={() => setFormData({ ...formData, subStatuses: [...formData.subStatuses, { id: '', subStatus: '' }] })}
                                            className="text-xs text-blue-500 hover:text-blue-700 border border-blue-500 px-2 py-0.5 rounded-lg"
                                        >
                                            Add Sub Status
                                        </button>
                                    </div>
                                )}

                                {formData.subStatuses.map((subStatus, index) => (
                                    <div key={index} className="flex items-center gap-2">
                                        <input
                                            type="text"
                                            name={`subStatus-${index}`}
                                            value={subStatus.subStatus}
                                            onChange={(e) => {
                                                const newSubStatus = [...formData.subStatuses];
                                                newSubStatus[index].subStatus = e.target.value;
                                                setFormData({ ...formData, subStatuses: newSubStatus });
                                            }}
                                            placeholder='Enter Sub Status'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const newSubStatus = formData.subStatuses.filter((_, i) => i !== index);
                                                setFormData({ ...formData, subStatuses: newSubStatus });
                                            }}
                                            className="mt-2 text-red-500 hover:text-red-700"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                        {title === 'Admission Status' && (
                            <div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Admission Status <span className="text-red-500">*</span></label> 
                                        <input
                                            type="text"
                                            name="admissionStatus"
                                            value={formData.admissionStatus}
                                            onChange={handleInputChange}
                                            placeholder='Enter Admission Status'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Level <span className="text-red-500">*</span></label>
                                        <input
                                            type="text"
                                            name="level"
                                            value={formData.level}
                                            onChange={handleInputChange}
                                            placeholder='Enter Level'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                    </div>
                                </div>

                                {formData.subAdmissionStatus.length < 1 && (
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, subAdmissionStatus: [{ id: '', subAdmissionStatus: '' }] })}
                                        className="mt-2 text-blue-500 hover:text-blue-700"
                                    >
                                        Need Sub Admission Statuses ? Click Here
                                    </button>
                                )}

                                {/* Sub Admission Statuses */}
                                {formData.subAdmissionStatus.length > 0 && (
                                    <div className="mt-4 flex items-center gap-2">
                                        <label className="block text-sm font-medium text-gray-700">Sub Admission Statuses</label>
                                        <button
                                            type="button"
                                            onClick={() => setFormData({ ...formData, subAdmissionStatus: [...formData.subAdmissionStatus, { id: '', subAdmissionStatus: '' }] })}
                                            className="text-xs text-blue-500 hover:text-blue-700 border border-blue-500 px-2 py-0.5 rounded-lg"
                                        >
                                            Add Sub Admission Status
                                        </button>
                                    </div>
                                )}
                                {formData.subAdmissionStatus.map((subAdmissionStatus, index) => (
                                    <div key={index} className="flex items-center gap-2">
                                        {/* <label className="block text-lg font-medium text-gray-700">{index + 1}</label> */}
                                        <input
                                            type="text"
                                            name={`subAdmissionStatus-${index}`}
                                            value={subAdmissionStatus.subAdmissionStatus}
                                            onChange={(e) => {
                                                const newSubSources = [...formData.subAdmissionStatus];
                                                newSubSources[index].subAdmissionStatus = e.target.value;
                                                setFormData({ ...formData, subAdmissionStatus: newSubSources });
                                            }}
                                            placeholder='Enter Sub Admission Status'
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const newSubSources = formData.subAdmissionStatus.filter((_, i) => i !== index);
                                                setFormData({ ...formData, subAdmissionStatus: newSubSources });
                                            }}
                                            className="mt-2 text-red-500 hover:text-red-700"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                        {title === 'Welcome Call Status' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Welcome Call Status</label>
                                <input
                                    type="text"
                                    name="welcomeCallByAdmissionTeamStatus"
                                    value={formData.welcomeCallByAdmissionTeamStatus}
                                    onChange={handleInputChange}
                                    placeholder='Enter Welcome Call Status'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Visa Processing' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Visa Processing</label>
                                <input
                                    type="text"
                                    name="visaFileProcessingStatus"
                                    value={formData.visaFileProcessingStatus}
                                    onChange={handleInputChange}
                                    placeholder='Enter Visa Processing Status'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Application Status' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Application Status</label>
                                <input
                                    type="text"
                                    name="applicationMovedStatus"
                                    value={formData.applicationMovedStatus}
                                    onChange={handleInputChange}
                                    placeholder='Enter Application Status'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Offer Letter Status' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Offer Letter Status</label>
                                <input
                                    type="text"
                                    name="offerLetterStatus"
                                    value={formData.offerLetterStatus}
                                    onChange={handleInputChange}
                                    placeholder='Enter Offer Letter Status'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Fee Payment Status' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Fee Payment Status</label>
                                <input
                                    type="text"
                                    name="feePaymentStatus"
                                    value={formData.feePaymentStatus}
                                    onChange={handleInputChange}
                                    placeholder='Enter Fee Payment Status'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'File Submission Status' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">File Submission Status</label>
                                <input
                                    type="text"
                                    name="fileSubmissionStatus"
                                    value={formData.fileSubmissionStatus}
                                    onChange={handleInputChange}
                                    placeholder='Enter File Submission Status'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Preffered Stream' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Preffered Stream</label>
                                <input
                                    type="text"
                                    name="prefferedStream"
                                    value={formData.prefferedStream}
                                    onChange={handleInputChange}
                                    placeholder='Enter Preffered Stream'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Program Type' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Program Type</label>
                                <input
                                    type="text"
                                    name="programType"
                                    value={formData.programType}
                                    onChange={handleInputChange}
                                    placeholder='Enter Program Type'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Super Agent' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Super Agent</label>
                                <input
                                    type="text"
                                    name="superAgent"
                                    value={formData.superAgent}
                                    onChange={handleInputChange}
                                    placeholder='Enter Super Agent Name'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Languages' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Language</label>
                                <input
                                    type="text"
                                    name="language"
                                    value={formData.language}
                                    onChange={handleInputChange}
                                    placeholder='Enter Language Name'
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                />
                            </div>
                        )}
                        {title === 'Registration fees' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Registration Fee Name</label>
                                <input
                                    type="text"
                                    name="registrationFeeName"
                                    value={formData.registrationFeeDetails.registrationFeeName}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    placeholder="Enter fee name"
                                />
                                <label className="block text-sm font-medium text-gray-700 mt-2">Registration Fee Amount</label>
                                <input
                                    type="text"
                                    name="registrationFeeAmount"
                                    value={formData.registrationFeeDetails.registrationFeeAmount}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    placeholder="Enter fee amount"
                                />
                            </div>
                        )}
                        {title === 'Document Categories' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Category Name</label>
                                <input
                                    type="text"
                                    name="categoryName"
                                    value={formData.documentCategory.categoryName}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    placeholder="Enter category name"
                                />

                                <label className="block text-sm font-medium text-gray-700 mt-4">Documents</label>
                                {formData.documentCategory.documentValues.map((document, index) => (
                                    <div key={index} className="flex gap-2 mt-2">
                                        <input
                                            type="text"
                                            value={document}
                                            onChange={(e) => {
                                                const newDocuments = [...formData.documentCategory.documentValues];
                                                newDocuments[index] = e.target.value;
                                                setFormData({
                                                    ...formData,
                                                    documentCategory: {
                                                        ...formData.documentCategory,
                                                        documentValues: newDocuments
                                                    }
                                                });
                                            }}
                                            className="flex-1 p-2 border rounded-md"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                            placeholder={`Document ${index + 1}`}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const newDocuments = formData.documentCategory.documentValues.filter((_, i) => i !== index);
                                                setFormData({
                                                    ...formData,
                                                    documentCategory: {
                                                        ...formData.documentCategory,
                                                        documentValues: newDocuments
                                                    }
                                                });
                                            }}
                                            className="px-3 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}

                                <button
                                    type="button"
                                    onClick={() => {
                                        setFormData({
                                            ...formData,
                                            documentCategory: {
                                                ...formData.documentCategory,
                                                documentValues: [...formData.documentCategory.documentValues, '']
                                            }
                                        });
                                    }}
                                    className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                                >
                                    Add Document
                                </button>

                                {formData.documentCategory.documentValues.length === 0 && (
                                    <p className="text-sm text-gray-500 mt-2">
                                        Click "Add Document" to start adding documents to this category.
                                    </p>
                                )}
                            </div>
                        )}
                        {(title === 'Departments' || title === 'Affiliate Departments') && (
                            <div className="grid grid-cols-1 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Department</label>
                                    <input
                                        type="text"
                                        name="department"
                                        value={formData.department}
                                        onChange={handleInputChange}
                                        placeholder='Enter Department Name'
                                        className="w-full p-2 border rounded-md mt-2"
                                        style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    />
                                </div>
                                <div>
                                    <label className="flex justify-between text-lg font-medium text-gray-700 bg-blue-50 pl-2 py-1 pr-2 rounded">
                                        Tabs
                                        <div className="flex items-center gap-2">
                                            <span className={`text-xs text-gray-500 ml-2 py-1 px-2 rounded ${(() => {
                                                const filteredPermissions = Object.values(formData.tabPermissions).filter((_, index) => {
                                                    if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                                                        return false;
                                                    }
                                                    return true;
                                                });
                                                return filteredPermissions.every(permission => permission.read) ? 'bg-rose-200' : 'bg-green-200';
                                            })()}`} onClick={() => handleSelectAll('tabPermissions', 'read')}>
                                                {(() => {
                                                    const filteredPermissions = Object.values(formData.tabPermissions).filter((_, index) => {
                                                        if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                                                            return false;
                                                        }
                                                        return true;
                                                    });
                                                    return filteredPermissions.every(permission => permission.read) ? 'Deselect All Read' : 'Select All Read';
                                                })()}
                                            </span>
                                            <span className={`text-xs text-gray-500 ml-2 py-1 px-2 rounded ${(() => {
                                                const filteredPermissions = Object.values(formData.tabPermissions).filter((_, index) => {
                                                    if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                                                        return false;
                                                    }
                                                    return true;
                                                });
                                                return filteredPermissions.every(permission => permission.write) ? 'bg-rose-200' : 'bg-green-200';
                                            })()}`} onClick={() => handleSelectAll('tabPermissions', 'write')}>
                                                {(() => {
                                                    const filteredPermissions = Object.values(formData.tabPermissions).filter((_, index) => {
                                                        if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                                                            return false;
                                                        }
                                                        return true;
                                                    });
                                                    return filteredPermissions.every(permission => permission.write) ? 'Deselect All Write' : 'Select All Write';
                                                })()}
                                            </span>
                                        </div>
                                    </label>
                                    <div className="block ml-3 mt-2 text-gray-700">
                                        {Object.values(formData.tabPermissions).map((permission, index) => {
                                            // Skip Initiate Services, Tasks, Registration and University Payout if title is 'Affiliate Departments'
                                            if (title === 'Affiliate Departments' && (index === 2 || index === 3 || index === 6 || index === 7)) {
                                                return null;
                                            }

                                            return (
                                                <div key={index} className="grid grid-cols-3 gap-1">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700">{permission.name}</label>
                                                    </div>
                                                    <div className="flex justify-evenly items-center hover:bg-gray-50 p-1 rounded transition-colors border-solid border-r border-gray-200">
                                                        <label className="block text-sm font-medium text-gray-700">Read</label>
                                                        <input
                                                            type="checkbox"
                                                            id={index.toString()}
                                                            name="read"
                                                            checked={permission.read}
                                                            onChange={handleInputChange}
                                                            className="w-5 h-5"
                                                        />
                                                    </div>
                                                    <div className="flex justify-evenly items-center hover:bg-gray-50 p-1 rounded transition-colors border-solid border-l border-gray-200">
                                                        <label className="block text-sm font-medium text-gray-700">Write</label>
                                                        <input
                                                            type="checkbox"
                                                            id={index.toString()}
                                                            name="write"
                                                            checked={permission.write}
                                                            onChange={handleInputChange}
                                                            className="w-5 h-5"
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div>
                                    <label className="flex justify-between text-lg font-medium text-gray-700 bg-blue-50 pl-2 py-1 rounded">
                                        Actions
                                        <div className="flex items-center gap-2">
                                            {(() => {
                                                const visiblePermissions = Object.values(formData.actionPermission).filter((_, index) => {
                                                    if (title === 'Affiliate Departments' && (index === 4 || index === 5 || index === 6 || index === 7)) {
                                                        return false;
                                                    }
                                                    return true;
                                                });
                                                const allSelected = visiblePermissions.every(permission => permission.allowed);
                                                return (
                                                    <span
                                                        className={`text-xs text-gray-500 mr-2 py-1 px-2 rounded ${allSelected ? 'bg-rose-200' : 'bg-green-200'}`}
                                                        onClick={() => handleSelectAll('actionPermission', 'allowed')}
                                                    >
                                                        {allSelected ? 'Deselect All' : 'Select All'}
                                                    </span>
                                                );
                                            })()}
                                        </div>
                                    </label>
                                    <div className="block ml-3 mt-2 text-gray-700">
                                        {Object.values(formData.actionPermission).map((permission, index) => {
                                            // Skip indices 4, 5, 6 and 7 if title is 'Affiliate Departments'
                                            if (title === 'Affiliate Departments' && (index === 4 || index === 5 || index === 6 || index === 7)) {
                                                return null;
                                            }
                                            return (
                                                <div key={index} className="grid grid-cols-3 gap-1">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700">
                                                            <img src={permission.img} alt={permission.name} className="w-5 h-5 inline-block mr-2" />
                                                            {permission.name === 'Delete' ? 'Delete (inactive)' : permission.name}
                                                        </label>
                                                    </div>
                                                    <div className="flex justify-evenly items-center hover:bg-gray-50 p-1 rounded transition-colors border-solid border-r border-gray-200">
                                                        <label className="block text-sm font-medium text-gray-700">Allow</label>
                                                        <input
                                                            type="checkbox"
                                                            id={index.toString()}
                                                            name="actionPermission"
                                                            checked={permission.allowed}
                                                            onChange={handleInputChange}
                                                            className="w-5 h-5"
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                {title !== 'Affiliate Departments' && (
                                    <>
                                        <div>
                                            <label className="flex justify-between text-lg font-medium text-gray-700 bg-blue-50 pl-2 py-1 rounded">
                                                Bulk Actions
                                                <div className="flex items-center gap-2">
                                                    <span className={`text-xs text-gray-500 mr-2 py-1 px-2 rounded ${Object.values(formData.bulkActionPermission).every(permission => permission.view) ? 'bg-rose-200' : 'bg-green-200'}`} onClick={() => handleSelectAll('bulkActionPermission', 'view')}>
                                                        {Object.values(formData.bulkActionPermission).every(permission => permission.view) ? 'Deselect All' : 'Select All'}
                                                    </span>
                                                </div>
                                            </label>
                                            <div className="block ml-3 mt-2 text-gray-700">
                                                {Object.values(formData.bulkActionPermission).map((permission, index) => (
                                                    <div key={index} className="grid grid-cols-3 gap-1">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700">{permission.name}</label>
                                                        </div>
                                                        <div className="flex justify-evenly items-center hover:bg-gray-50 p-1 rounded transition-colors border-solid border-r border-gray-200">
                                                            <label className="block text-sm font-medium text-gray-700">Allow</label>
                                                            <input
                                                                type="checkbox"
                                                                id={index.toString()}
                                                                name="bulkActionPermission"
                                                                checked={permission.view}
                                                                onChange={handleInputChange}
                                                                className="w-5 h-5"
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {/* Filter Settings Section */}
                                        <div className="max-w-2xl">
                                            <label className="flex justify-between text-lg font-medium text-gray-700 bg-blue-50 pl-2 py-1 pr-2 rounded">
                                                Filter Settings
                                                <div className="flex items-center gap-2">
                                                    <span className={`text-xs text-gray-500 mr-2 py-1 px-2 rounded ${filterSettings && filterSettings.length > 0 &&
                                                        filterSettings.every(filter => formData.selectedFilterIds.includes(filter.id))
                                                        ? 'bg-rose-200' : 'bg-green-200'
                                                        }`} onClick={() => {
                                                            if (filterSettings && filterSettings.length > 0) {
                                                                const allSelected = filterSettings.every(filter => formData.selectedFilterIds.includes(filter.id));
                                                                if (allSelected) {
                                                                    setFormData(prev => ({ ...prev, selectedFilterIds: [] }));
                                                                } else {
                                                                    setFormData(prev => ({ ...prev, selectedFilterIds: filterSettings.map(filter => filter.id) }));
                                                                }
                                                            }
                                                        }}>
                                                        {filterSettings && filterSettings.length > 0 &&
                                                            filterSettings.every(filter => formData.selectedFilterIds.includes(filter.id))
                                                            ? 'Deselect All' : 'Select All'}
                                                    </span>
                                                </div>
                                            </label>
                                            <div className="border border-gray-200 rounded-lg p-3 mt-2 bg-white max-h-96 overflow-y-auto">
                                                {filterSettings && filterSettings.length > 0 ? (
                                                    <div className="space-y-2">
                                                        {filterSettings.map((filter) => (
                                                            <div key={filter.id} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded transition-colors">
                                                                <div className="flex-1">
                                                                    <label className="block text-sm font-medium text-gray-700 cursor-pointer">
                                                                        {filter.data.title}
                                                                        {filter.id.startsWith('mock_') && (
                                                                            <span className="ml-1 text-xs text-blue-500">(Mock)</span>
                                                                        )}
                                                                    </label>
                                                                    {filter.data.description && (
                                                                        <p className="text-xs text-gray-500 mt-1">{filter.data.description}</p>
                                                                    )}
                                                                </div>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={formData.selectedFilterIds.includes(filter.id)}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked;
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            selectedFilterIds: isChecked
                                                                                ? [...prev.selectedFilterIds, filter.id]
                                                                                : prev.selectedFilterIds.filter(id => id !== filter.id)
                                                                        }));
                                                                    }}
                                                                    className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-6">
                                                        <p className="text-sm text-gray-500 mb-3">No filter settings available</p>
                                                        <p className="text-xs text-gray-400 mb-2">
                                                            The filterSettings collection could not be loaded.
                                                        </p>
                                                        <p className="text-xs text-gray-600">
                                                            You can still create departments without filter settings.
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* <div>
                                            <label className="flex justify-between text-lg font-medium text-gray-700 bg-blue-50 pl-2 py-1 rounded">
                                                Sidebar Navigations
                                                <div className="flex items-center gap-2">
                                                    <span className={`text-xs text-gray-500 mr-2 py-1 px-2 rounded ${Object.values(formData.sidebarItems).every(permission => permission.isVisible) ? 'bg-rose-200' : 'bg-green-200'}`} onClick={() => handleSelectAll('sidebarItems', 'isVisible')}>
                                                        {Object.values(formData.sidebarItems).every(permission => permission.isVisible) ? 'Deselect All' : 'Select All'}
                                                    </span>
                                                </div>
                                            </label>
                                            <div className="block ml-3 mt-2 text-gray-700">
                                                {Object.values(formData.sidebarItems).map((permission, index) => (
                                                    <div key={index} className="grid grid-cols-3 gap-1">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700">{permission.name}
                                                                {permission?.targeted && (
                                                                    <span className='ml-2 font-light text-sm text-gray-600'>{`(${permission?.targeted} only)`}</span>
                                                                )}
                                                            </label>
                                                        </div>
                                                        <div className="flex justify-evenly items-center hover:bg-gray-50 p-1 rounded transition-colors border-solid border-r border-gray-200">
                                                            <label className="block text-sm font-medium text-gray-700">Allow</label>
                                                            <input
                                                                type="checkbox"
                                                                id={index.toString()}
                                                                name="sidebarItems"
                                                                checked={permission.isVisible}
                                                                onChange={handleInputChange}
                                                                className="w-5 h-5"
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div> */}
                                    </>
                                )}
                            </div>
                        )}
                        {(title === 'Pipeline') && (
                            // box with title checkpoint 1
                            <div className="col-span-2">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex items-center gap-3">
                                        <h5 className="text-xl font-bold tracking-tight text-black">Pipeline Name</h5>
                                        <input
                                            type="text"
                                            placeholder='Enter Pipline Name'
                                            className="w-80 py-2 px-4 border rounded-full"
                                            style={{ border: '1px solid #3483BE' }}
                                            value={pipelineName}
                                            onChange={(e) => setPipelineName(e.target.value)}
                                        />
                                    </div>
                                    <button className="flex items-center gap-2 bg-blue-500 text-white hover:bg-blue-700 rounded-full px-4 py-2 transition-colors"
                                        onClick={(e) => handleAddCheckpoint(e)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                        </svg>
                                        <span className="text-sm font-medium">Add Checkpoint</span>
                                    </button>
                                </div>
                                <label className="text-xl font-bold tracking-tight text-black">Pipeline Description</label>
                                <textarea
                                    placeholder={`Enter Pipeline Description`}
                                    className="w-full p-2 border rounded-md mt-2"
                                    style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    rows={3}
                                    value={pipelineDescription}
                                    onChange={(e) => setPipelineDescription(e.target.value)}
                                />

                                {pipelineData.map((checkpoint, index) => (
                                    <div className={`w-full mt-2 p-6 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl shadow-xl hover:bg-white/20 hover:shadow-2xl hover:border-white/30`}>
                                        {/* Title with Plus Icon */}
                                        <div className="flex items-center gap-3 mb-2">
                                            <h5 className="text-xl font-bold tracking-tight text-black">Checkpoint {index + 1}</h5>
                                            <input type="text" placeholder={`Enter Checkpoint ${index + 1} Name`} className="w-[30%] py-1 px-2 border rounded-md" style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                                value={checkpoint.checkpointName || ''}
                                                onChange={(e) => handleCheckpointNameChange(index, e)}
                                            />
                                        </div>
                                        <button
                                            onClick={() => handleRemoveCheckpoint(index)}
                                            className="absolute top-4 right-4 font-semibold text-3xl"
                                            style={{ background: 'linear-gradient(270deg, #A7C8E7 0%, #00A6D9 100%)', WebkitBackgroundClip: 'text', color: 'transparent' }}
                                        >
                                            <img src={`${process.env.PUBLIC_URL}/images/desktop/close-btn.svg`} alt="Close" className="w-5 h-5" />
                                        </button>
                                        {/* Description */}
                                        {/* <label className="block text-sm font-medium text-gray-700">Checkpoint {index + 1} Description</label>
                                        <textarea
                                            placeholder={`Enter Checkpoint ${index + 1} Description`}
                                            className="w-full p-2 border rounded-md mt-2"
                                            style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                            rows={3}
                                            value={checkpoint.checkpointDescription || ''}
                                            onChange={(e) => handleCheckpointDescriptionChange(index, e)}
                                        /> */}
                                        {/* Criteria and values */}
                                        <div className="grid grid-cols-1 gap-4 mt-4">
                                            {checkpoint.criteria.length > 0 && checkpoint.criteria.map((optionData, idx) => (
                                                <>
                                                    <div key={idx} className="flex items-start gap-2">
                                                        <select
                                                            name='criteriaId'
                                                            className="flex-1 p-2 border border-blue-500 rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => handleCriteriaInputChange(index, idx, e)}
                                                            value={optionData.criteriaName || ''}
                                                        >0
                                                            <option value="">Select Criteria</option>
                                                            {criteriaOptions.map((criteria, idx) => (
                                                                <option key={idx} value={criteria.label}>
                                                                    {criteria.label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        <div className="flex flex-col flex-1">
                                                            <select
                                                                className="w-full p-2 border border-blue-500 rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                                onChange={(e) => {
                                                                    if (e.target.value === "select-all") {
                                                                        // Handle select all
                                                                        const allOptions = optionsData.map(data => ({
                                                                            id: data.criteriaId,
                                                                            name: data.value
                                                                        }));
                                                                        handleValueChange(index, idx, { target: { value: allOptions } });
                                                                    } else {
                                                                        handleValueChange(index, idx, e);
                                                                    }
                                                                }}
                                                                value={optionData.criteriaValue.map(data => data.id).join(',') || ''}
                                                                onFocus={() => fetchCriteriaOptions(optionData.criteriaName)}
                                                            >
                                                                <option value="">Select Value</option>
                                                                <option value="select-all">Select All</option>
                                                                {optionsData.map((data, idx) => (
                                                                    <option key={idx} value={data?.criteriaId}>
                                                                        {data.value}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                            {optionData.criteriaValue.length > 0 && (
                                                                <div className="mt-2">
                                                                    <div className="flex justify-between items-center mb-1">
                                                                        <span className="text-sm text-gray-500">
                                                                            {optionData.criteriaValue.length} selected
                                                                        </span>
                                                                        {optionData.criteriaValue.length > 1 && (
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    // Clear all selected values
                                                                                    handleValueChange(index, idx, { target: { value: [] } });
                                                                                }}
                                                                                className="text-xs text-blue-500 hover:text-blue-700"
                                                                            >
                                                                                Clear All
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    <div className="flex flex-wrap gap-2">
                                                                        {optionData.criteriaValue.map((data, valueIdx) => (
                                                                            <div
                                                                                key={valueIdx}
                                                                                className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-800 border border-gray-200"
                                                                            >
                                                                                <span>{data.name}</span>
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => handleRemoveItem(index, idx, valueIdx)}
                                                                                    className="text-red-500 hover:text-red-700 transition-colors duration-200 p-1 hover:bg-red-50 rounded-full"
                                                                                    aria-label="Remove item"
                                                                                >
                                                                                    <svg
                                                                                        className="w-3 h-3"
                                                                                        fill="none"
                                                                                        stroke="currentColor"
                                                                                        viewBox="0 0 24 24"
                                                                                    >
                                                                                        <path
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                            strokeWidth={2}
                                                                                            d="M6 18L18 6M6 6l12 12"
                                                                                        />
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <button
                                                            onClick={() => handleRemoveCriteria(index, idx)}
                                                            type='button'
                                                            className="font-semibold text-3xl mt-2"
                                                            style={{ background: 'linear-gradient(270deg, #A7C8E7 0%, #00A6D9 100%)', WebkitBackgroundClip: 'text', color: 'transparent' }}
                                                        >
                                                            <img src={`${process.env.PUBLIC_URL}/images/desktop/close-btn.svg`} alt="Close" className="w-4 h-4" />
                                                        </button>
                                                    </div>
                                                    {/* if index is last index */}
                                                    {idx === checkpoint.criteria.length - 1 && (
                                                        <div className="flex justify-end mt-4">
                                                            <button className="flex items-center gap-2 bg-blue-500 text-white hover:bg-blue-700 rounded-full px-4 py-2 transition-colors"
                                                                onClick={() => handleAddCriteria(index, idx)}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                                                </svg>
                                                                <span className="text-sm font-medium">Add Criteria</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {(title === 'Filter Button') && (
                            <div className="col-span-2">
                                <div className="flex items-center justify-between mb-4">
                                    <h5 className="text-xl font-bold tracking-tight text-black mb-4">Filter Button Settings <span className="text-sm text-red-600 mb-2">(upto 30 filters combinations can be added)</span> </h5>

                                    {/* Total count by allowed count */}
                                    <div className={`text-xs text-gray-600 font-semibold rounded-lg px-2 py-1 ${checkBoxActive ? 'bg-red-400 text-white' : 'bg-green-300 text-black'}`}>
                                        {Object.values(formData.filterButton).filter(arr => arr.length > 0).reduce((acc, curr) => acc * curr.length, 1)} / 30
                                    </div>
                                </div>
                                {/* Name of filter button */}
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700">Filter Button Name</label>
                                    <input
                                        type="text"
                                        name="filterButtonName"
                                        value={filterButtonName}
                                        onChange={(e) => setFilterButtonName(e.target.value)}
                                        placeholder='Enter Filter Button Name'
                                        className="w-full p-2 border rounded-md mt-2"
                                        style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Filter Button Description</label>
                                    <textarea
                                        name="filterButtonDescription"
                                        value={filterButtonDescription}
                                        onChange={(e) => setFilterButtonDescription(e.target.value)}
                                        placeholder='Enter Filter Button Description'
                                        className="w-full p-2 border rounded-md mt-2"
                                        style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                        rows={3}
                                    />
                                    <div className='grid grid-cols-2 gap-4'>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Filter Button Color</label>
                                            <input
                                                type="text"
                                                name="color"
                                                value={filterButtonColor}
                                                onChange={(e) => setFilterButtonColor(e.target.value)}
                                                placeholder='Enter or Select Color'
                                                className="w-full p-2 border rounded-md mt-2"
                                                style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Color Picker</label>
                                            <input
                                                type="color"
                                                name="color"
                                                value={filterButtonColor}
                                                onChange={(e) => setFilterButtonColor(e.target.value)}
                                                className="appearance-none bg-transparent w-[100%] h-[40px] border-none outline-none cursor-pointer rounded-xl mt-2"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {getTabContent()}
                            </div>
                        )}
                        <div className="col-span-2 mt-8 flex justify-end gap-4">

                            {/* GradientSubmitButton */}
                            <GradientSubmitButton
                                type="submit"
                                onClick={() => { }} // Optional, or use native form submit
                                loading={isUpdating}
                                label={action === 'add' ? 'Add' : 'Update'}
                                loadingLabel={action === 'add' ? 'Adding...' : 'Updating...'}
                                disabled={isUpdating || checkBoxActive}
                            />
                            {/* Cancel Button */}
                            <button
                                type="button"
                                onClick={() => onClose('')}
                                className="px-8 py-2 border rounded-3xl text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                                disabled={isUpdating || checkBoxActive}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {showToast && (
                <Toast
                    message={toastMessage}
                    isError={
                        toastMessage.includes('Error') ||
                        toastMessage.includes('Cannot') ||
                        toastMessage.includes('Failed')
                    }
                    show={showToast}
                    onClose={() => setShowToast(false)}
                />
            )}
        </div>

    )
}

export default SettingsModal
